/* tslint:disable */
//  This file was automatically generated and should not be edited.

// The type of flight, international or domestic.
export enum FlightTypeEnum {
  Domestic = "Domestic",
  International = "International",
}


export interface BookerInput {
  name?: string | null,
  email?: string | null,
  localeId?: string | null,
  accountsEmail?: string | null,
  invoiceTerms?: number | null,
  loyaltyDiscount?: number | null,
  address?: AddressInput | null,
  giftLoyaltyCredits?: boolean | null,
};

export interface AddressInput {
  attention: string,
  address: string,
  suburb: string,
  state: string,
  postCode: string,
  country: string,
};

export interface DriverInput {
  bookerId?: string | null,
  name: string,
  mobileNumber: string,
  active: boolean,
};

export enum ExtraChargeType {
  AIRPORT_PARKING_TIME = "AIRPORT_PARKING_TIME",
  CHANGED_DROPOFF_ADDRESS = "CHANGED_DROPOFF_ADDRESS",
  CHANGED_PICKUP_ADDRESS = "CHANGED_PICKUP_ADDRESS",
  INITIAL_LOYALTY_CREDIT = "INITIAL_LOYALTY_CREDIT",
  OTHER = "OTHER",
  REFERRER_LOYALTY_CREDIT = "REFERRER_LOYALTY_CREDIT",
  WAITING_TIME = "WAITING_TIME",
}


export enum BookingPaidBy {
  not_specified = "not_specified",
  on_account = "on_account",
  other = "other",
  paid_in_car_income = "paid_in_car_income",
  paid_in_car_non_income = "paid_in_car_non_income",
  registered_credit_card = "registered_credit_card",
}


export enum JobStatus {
  COMPLETE = "COMPLETE",
  FAILED = "FAILED",
  PENDING = "PENDING",
}


// The different brands of credit card
export enum CardBrandEnum {
  American_Express = "American_Express",
  Diners_Club = "Diners_Club",
  Discover = "Discover",
  JCB = "JCB",
  MasterCard = "MasterCard",
  UnionPay = "UnionPay",
  Unknown = "Unknown",
  Visa = "Visa",
}


export interface BookingDetails {
  passengers: Array< PassengerInput >,
  passengerCount: number,
  journey: JourneyInput,
  bookingDateTime: string,
  babySeatsForward?: number | null,
  babySeatsBackward?: number | null,
  boosterSeats?: number | null,
  wantPeopleMover?: boolean | null,
  airportPickup?: AirportStopInput | null,
  airportDropoff?: AirportStopInput | null,
};

export interface PassengerInput {
  id?: string | null,
  name: string,
  email?: string | null,
  mobile?: string | null,
  phone?: string | null,
};

export interface JourneyInput {
  originId: string,
  destinationId: string,
  waypointIds: Array< string >,
};

export interface AirportStopInput {
  airlineCode: string,
  flightType: FlightTypeEnum,
  flightNumber: string,
};

export interface StringOrNull {
  string?: string | null,
};

export interface PromotionInput {
  promoCode?: string | null,
  giftLoyaltyCredits: boolean,
};

export interface OptionalCharge {
  value?: ChargeInput | null,
};

export interface ChargeInput {
  amount: number,
  description: string,
};

export interface ExtraChargeInput {
  id?: string | null,
  type: ExtraChargeType,
  description: string,
  amount: number,
};

export interface UUIDOrNull {
  uuid?: string | null,
};

export interface DriverUpdate {
  // Null means "do not change"
  status?: BookingDriverState | null,
  // Null means "do not change"
  driverNotes?: string | null,
};

export enum BookingDriverState {
  Complete = "Complete",
  Confirmed = "Confirmed",
}


// A synthesized state of a booking for admin purposes
export enum BookingState {
  Assigned = "Assigned",
  Cancelled = "Cancelled",
  Complete = "Complete",
  Confirmed = "Confirmed",
  Hidden = "Hidden",
  Invoiced = "Invoiced",
  Priced = "Priced",
  Unpriced = "Unpriced",
}


export enum PageDirection {
  After = "After",
  Before = "Before",
}


export interface BookingsFilter {
  state: BookingsState,
  bookerId?: string | null,
  driverId?: string | null,
};

// A bookings query filter type
export enum BookingsState {
  ALL = "ALL",
  CANCELLED = "CANCELLED",
  DONE = "DONE",
  HIDDEN = "HIDDEN",
  INVOICED = "INVOICED",
  PENDING = "PENDING",
}


export interface BookingsSeek {
  bookingDateTime: string,
  // Optional
  bookingId?: string | null,
  direction: PageDirection,
};

export enum ChargeType {
  AIRPORT_PICKUP = "AIRPORT_PICKUP",
  BABY_OR_BOOSTER = "BABY_OR_BOOSTER",
  BOOKING_FEE = "BOOKING_FEE",
  DISTANCE = "DISTANCE",
  EXTRA_STOPS = "EXTRA_STOPS",
  LNS = "LNS",
  MINIMUM = "MINIMUM",
  PEOPLE_MOVER = "PEOPLE_MOVER",
  TRIP_LEVY = "TRIP_LEVY",
}


// The category of a place, used for common places.
export enum PlaceCategory {
  Airport = "Airport",
  Hospital = "Hospital",
  Place = "Place",
}


// The type of a place derived from the google types array.
export enum PlaceType {
  Place = "Place",
  Train = "Train",
  Tram = "Tram",
}


export interface CommonPlaceInput {
  id?: string | null,
  placeId: string,
  localeId: string,
  label: string,
  shortLabel: string,
  suggest: boolean,
  category: PlaceCategory,
};

export interface AirportAirlinesQueryVariables {
  airportPlaceId: string,
};

export interface AirportAirlinesQuery {
  airportAirlines:  Array< {
    id: string,
    name: string,
  } >,
};

export interface ShowTestModeBandQuery {
  showTestModeBand: boolean,
};

export interface Auth0ConfigQuery {
  auth0Config:  {
    // Do not add clientSecret here!
    domain: string,
    clientId: string,
    loginCallbackUrl: string,
    logoutUrl: string,
    nonce: string,
  },
};

export interface BookerQuery {
  booker: ( {
      __typename: "BookerOrNull",
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } | null,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface BookerByNewBookerSecretQueryVariables {
  secret: string,
};

export interface BookerByNewBookerSecretQuery {
  bookerByNewBookerSecret:  {
    name: string,
    id: string,
    email: string,
    isAdmin: boolean,
    isDriver: boolean,
    defaultLocale:  {
      id: string,
      label: string,
      mapLatitude: number,
      mapLongitude: number,
      countryCode: string,
    },
    isEmailVerified: boolean,
    invoiceTerms: number,
    isSocialAccount: boolean,
    loyaltyDiscount: number,
    loyaltyCode: string,
    giftLoyaltyCredits: boolean,
  } | null,
};

export interface BookerProfileDataQueryVariables {
  forBookerId?: string | null,
};

export interface BookerProfileDataQuery {
  booker: ( {
      __typename: "BookerOrNull",
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
        accountsEmail: string,
        address:  {
          attention: string,
          address: string,
          suburb: string,
          postCode: string,
          state: string,
          country: string,
        },
      } | null,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface CreateBookerMutationVariables {
  name?: string | null,
  email: string,
  matchByEmail?: boolean | null,
};

export interface CreateBookerMutation {
  createBooker: ( {
      __typename: "Booker",
      name: string,
      id: string,
      email: string,
      isAdmin: boolean,
      isDriver: boolean,
      defaultLocale:  {
        id: string,
        label: string,
        mapLatitude: number,
        mapLongitude: number,
        countryCode: string,
      },
      isEmailVerified: boolean,
      invoiceTerms: number,
      isSocialAccount: boolean,
      loyaltyDiscount: number,
      loyaltyCode: string,
      giftLoyaltyCredits: boolean,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface UpdateBookerMutationVariables {
  forBookerId: string,
  booker: BookerInput,
};

export interface UpdateBookerMutation {
  updateBooker: ( {
      __typename: "Booker",
      name: string,
      id: string,
      email: string,
      isAdmin: boolean,
      isDriver: boolean,
      defaultLocale:  {
        id: string,
        label: string,
        mapLatitude: number,
        mapLongitude: number,
        countryCode: string,
      },
      isEmailVerified: boolean,
      invoiceTerms: number,
      isSocialAccount: boolean,
      loyaltyDiscount: number,
      loyaltyCode: string,
      giftLoyaltyCredits: boolean,
      accountsEmail: string,
      address:  {
        attention: string,
        address: string,
        suburb: string,
        postCode: string,
        state: string,
        country: string,
      },
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface BookersQueryVariables {
  searchTerm?: string | null,
};

export interface BookersQuery {
  bookers: ( {
      __typename: "Bookers",
      bookers:  Array< {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } >,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface DriversQueryVariables {
  active?: boolean | null,
};

export interface DriversQuery {
  drivers: ( {
      __typename: "Drivers",
      drivers:  Array< {
        id: string,
        booker:  {
          name: string,
          id: string,
          email: string,
          isAdmin: boolean,
          isDriver: boolean,
          defaultLocale:  {
            id: string,
            label: string,
            mapLatitude: number,
            mapLongitude: number,
            countryCode: string,
          },
          isEmailVerified: boolean,
          invoiceTerms: number,
          isSocialAccount: boolean,
          loyaltyDiscount: number,
          loyaltyCode: string,
          giftLoyaltyCredits: boolean,
        } | null,
        name: string,
        mobileNumber: string,
        active: boolean,
      } >,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface UpsertDriverMutationVariables {
  id?: string | null,
  driver: DriverInput,
};

export interface UpsertDriverMutation {
  upsertDriver: ( {
      __typename: "Driver",
      id: string,
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } | null,
      name: string,
      mobileNumber: string,
      active: boolean,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface BasicDriversQueryVariables {
  active?: boolean | null,
};

export interface BasicDriversQuery {
  drivers: ( {
      __typename: "Drivers",
      drivers:  Array< {
        id: string,
        booker:  {
          id: string,
        } | null,
        name: string,
      } >,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface CancelBookingMutationVariables {
  id: string,
};

export interface CancelBookingMutation {
  cancelBooking: ( {
      __typename: "Booking",
      id: string,
      number: string,
      bookingDate: string,
      bookingHour: number,
      bookingMinute: number,
      isCancelled: boolean,
      notes: string,
      passengerCount: number,
      babySeatsForward: number,
      babySeatsBackward: number,
      boosterSeats: number,
      wantPeopleMover: boolean,
      price:  {
        description: string,
        amount: number,
      } | null,
      status:  {
        bookingTimestamp: string,
        bookingDay7am: string,
        bookingDayBefore7pm: string,
      },
      journey:  {
        id: string,
        origin:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        destination:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        waypoints:  Array< {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        } >,
        distance: number | null,
        timeZoneId: string,
      },
      airportPickup:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      airportDropoff:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      passengers:  Array< {
        id: string,
        name: string,
        email: string | null,
        mobile: string | null,
        phone: string | null,
      } >,
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } | null,
      createdBy:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      },
      driver:  {
        id: string,
        booker:  {
          id: string,
        } | null,
        name: string,
      } | null,
      driverNotes: string,
      isConfirmed: boolean | null,
      isComplete: boolean,
      invoice:  {
        id: string,
        number: string,
        // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
        // Xero you can use this to check if it's null without fetching the Xero data.
        xeroInvoiceReady: boolean,
      } | null,
      isHidden: boolean,
      extraCharges:  Array< {
        amount: number,
        description: string,
        id: string,
        type: ExtraChargeType,
        invoice:  {
          id: string,
          number: string,
          // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
          // Xero you can use this to check if it's null without fetching the Xero data.
          xeroInvoiceReady: boolean,
        } | null,
      } >,
      automaticExtraCharges:  Array< {
        amount: number,
        description: string,
        type: ExtraChargeType,
      } >,
      stripeCard:  {
        id: string,
        last4: string | null,
        brand: CardBrandEnum | null,
        expiryYear: number | null,
        expiryMonth: number | null,
        bookerName: string,
        bookerId: string,
      } | null,
      paymentLink:  {
        toEmail: string,
        // I can't figure out right now whether it would be safe to expose the entire booker object here
        // so we're just exposing the booker ID for now.
        bookerId: string | null,
      } | null,
      promoCode: string | null,
      giftLoyaltyCredits: boolean,
      paidBy: BookingPaidBy,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface UncancelBookingMutationVariables {
  id: string,
};

export interface UncancelBookingMutation {
  uncancelBooking: ( {
      __typename: "Booking",
      id: string,
      number: string,
      bookingDate: string,
      bookingHour: number,
      bookingMinute: number,
      isCancelled: boolean,
      notes: string,
      passengerCount: number,
      babySeatsForward: number,
      babySeatsBackward: number,
      boosterSeats: number,
      wantPeopleMover: boolean,
      price:  {
        description: string,
        amount: number,
      } | null,
      status:  {
        bookingTimestamp: string,
        bookingDay7am: string,
        bookingDayBefore7pm: string,
      },
      journey:  {
        id: string,
        origin:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        destination:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        waypoints:  Array< {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        } >,
        distance: number | null,
        timeZoneId: string,
      },
      airportPickup:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      airportDropoff:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      passengers:  Array< {
        id: string,
        name: string,
        email: string | null,
        mobile: string | null,
        phone: string | null,
      } >,
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } | null,
      createdBy:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      },
      driver:  {
        id: string,
        booker:  {
          id: string,
        } | null,
        name: string,
      } | null,
      driverNotes: string,
      isConfirmed: boolean | null,
      isComplete: boolean,
      invoice:  {
        id: string,
        number: string,
        // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
        // Xero you can use this to check if it's null without fetching the Xero data.
        xeroInvoiceReady: boolean,
      } | null,
      isHidden: boolean,
      extraCharges:  Array< {
        amount: number,
        description: string,
        id: string,
        type: ExtraChargeType,
        invoice:  {
          id: string,
          number: string,
          // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
          // Xero you can use this to check if it's null without fetching the Xero data.
          xeroInvoiceReady: boolean,
        } | null,
      } >,
      automaticExtraCharges:  Array< {
        amount: number,
        description: string,
        type: ExtraChargeType,
      } >,
      stripeCard:  {
        id: string,
        last4: string | null,
        brand: CardBrandEnum | null,
        expiryYear: number | null,
        expiryMonth: number | null,
        bookerName: string,
        bookerId: string,
      } | null,
      paymentLink:  {
        toEmail: string,
        // I can't figure out right now whether it would be safe to expose the entire booker object here
        // so we're just exposing the booker ID for now.
        bookerId: string | null,
      } | null,
      promoCode: string | null,
      giftLoyaltyCredits: boolean,
      paidBy: BookingPaidBy,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface ResendBookingEmailMutationVariables {
  id: string,
};

export interface ResendBookingEmailMutation {
  resendBookingEmail:  {
    __typename: "Error",
    message: string,
    // The value of this is meaningless. It's just here because this type is used as a union with
    // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
    // https://github.com/apollographql/apollo-client/issues/2510
    // It also has to be a UUID rather than a dumb String or Int because you can't select a field
    // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
    // another type in the union. :(
    id: string,
  } | null,
};

export interface InvoiceBookingsMutationVariables {
  ids: Array< string >,
};

export interface InvoiceBookingsMutation {
  invoiceBookings: ( {
      __typename: "Bookings",
      bookings:  Array< {
        id: string,
        number: string,
        bookingDate: string,
        bookingHour: number,
        bookingMinute: number,
        isCancelled: boolean,
        notes: string,
        passengerCount: number,
        babySeatsForward: number,
        babySeatsBackward: number,
        boosterSeats: number,
        wantPeopleMover: boolean,
        price:  {
          description: string,
          amount: number,
        } | null,
        status:  {
          bookingTimestamp: string,
          bookingDay7am: string,
          bookingDayBefore7pm: string,
        },
        journey:  {
          id: string,
          origin:  {
            id: string,
            googlePlaceId: string,
            optionalName: string | null,
            address: string,
            type: PlaceType,
            category: PlaceCategory,
            isAirportStop: boolean,
          },
          destination:  {
            id: string,
            googlePlaceId: string,
            optionalName: string | null,
            address: string,
            type: PlaceType,
            category: PlaceCategory,
            isAirportStop: boolean,
          },
          waypoints:  Array< {
            id: string,
            googlePlaceId: string,
            optionalName: string | null,
            address: string,
            type: PlaceType,
            category: PlaceCategory,
            isAirportStop: boolean,
          } >,
          distance: number | null,
          timeZoneId: string,
        },
        airportPickup:  {
          id: string,
          airlineCode: string,
          flightType: FlightTypeEnum,
          flightNumber: string,
        } | null,
        airportDropoff:  {
          id: string,
          airlineCode: string,
          flightType: FlightTypeEnum,
          flightNumber: string,
        } | null,
        passengers:  Array< {
          id: string,
          name: string,
          email: string | null,
          mobile: string | null,
          phone: string | null,
        } >,
        booker:  {
          name: string,
          id: string,
          email: string,
          isAdmin: boolean,
          isDriver: boolean,
          defaultLocale:  {
            id: string,
            label: string,
            mapLatitude: number,
            mapLongitude: number,
            countryCode: string,
          },
          isEmailVerified: boolean,
          invoiceTerms: number,
          isSocialAccount: boolean,
          loyaltyDiscount: number,
          loyaltyCode: string,
          giftLoyaltyCredits: boolean,
        } | null,
        createdBy:  {
          name: string,
          id: string,
          email: string,
          isAdmin: boolean,
          isDriver: boolean,
          defaultLocale:  {
            id: string,
            label: string,
            mapLatitude: number,
            mapLongitude: number,
            countryCode: string,
          },
          isEmailVerified: boolean,
          invoiceTerms: number,
          isSocialAccount: boolean,
          loyaltyDiscount: number,
          loyaltyCode: string,
          giftLoyaltyCredits: boolean,
        },
        driver:  {
          id: string,
          booker:  {
            id: string,
          } | null,
          name: string,
        } | null,
        driverNotes: string,
        isConfirmed: boolean | null,
        isComplete: boolean,
        invoice:  {
          id: string,
          number: string,
          // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
          // Xero you can use this to check if it's null without fetching the Xero data.
          xeroInvoiceReady: boolean,
        } | null,
        isHidden: boolean,
        extraCharges:  Array< {
          amount: number,
          description: string,
          id: string,
          type: ExtraChargeType,
          invoice:  {
            id: string,
            number: string,
            // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
            // Xero you can use this to check if it's null without fetching the Xero data.
            xeroInvoiceReady: boolean,
          } | null,
        } >,
        automaticExtraCharges:  Array< {
          amount: number,
          description: string,
          type: ExtraChargeType,
        } >,
        stripeCard:  {
          id: string,
          last4: string | null,
          brand: CardBrandEnum | null,
          expiryYear: number | null,
          expiryMonth: number | null,
          bookerName: string,
          bookerId: string,
        } | null,
        paymentLink:  {
          toEmail: string,
          // I can't figure out right now whether it would be safe to expose the entire booker object here
          // so we're just exposing the booker ID for now.
          bookerId: string | null,
        } | null,
        promoCode: string | null,
        giftLoyaltyCredits: boolean,
        paidBy: BookingPaidBy,
      } >,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface SetBookingsHiddenMutationVariables {
  ids: Array< string >,
  hidden: boolean,
};

export interface SetBookingsHiddenMutation {
  setBookingsHidden: ( {
      __typename: "Bookings",
      bookings:  Array< {
        id: string,
        number: string,
        bookingDate: string,
        bookingHour: number,
        bookingMinute: number,
        isCancelled: boolean,
        notes: string,
        passengerCount: number,
        babySeatsForward: number,
        babySeatsBackward: number,
        boosterSeats: number,
        wantPeopleMover: boolean,
        price:  {
          description: string,
          amount: number,
        } | null,
        status:  {
          bookingTimestamp: string,
          bookingDay7am: string,
          bookingDayBefore7pm: string,
        },
        journey:  {
          id: string,
          origin:  {
            id: string,
            googlePlaceId: string,
            optionalName: string | null,
            address: string,
            type: PlaceType,
            category: PlaceCategory,
            isAirportStop: boolean,
          },
          destination:  {
            id: string,
            googlePlaceId: string,
            optionalName: string | null,
            address: string,
            type: PlaceType,
            category: PlaceCategory,
            isAirportStop: boolean,
          },
          waypoints:  Array< {
            id: string,
            googlePlaceId: string,
            optionalName: string | null,
            address: string,
            type: PlaceType,
            category: PlaceCategory,
            isAirportStop: boolean,
          } >,
          distance: number | null,
          timeZoneId: string,
        },
        airportPickup:  {
          id: string,
          airlineCode: string,
          flightType: FlightTypeEnum,
          flightNumber: string,
        } | null,
        airportDropoff:  {
          id: string,
          airlineCode: string,
          flightType: FlightTypeEnum,
          flightNumber: string,
        } | null,
        passengers:  Array< {
          id: string,
          name: string,
          email: string | null,
          mobile: string | null,
          phone: string | null,
        } >,
        booker:  {
          name: string,
          id: string,
          email: string,
          isAdmin: boolean,
          isDriver: boolean,
          defaultLocale:  {
            id: string,
            label: string,
            mapLatitude: number,
            mapLongitude: number,
            countryCode: string,
          },
          isEmailVerified: boolean,
          invoiceTerms: number,
          isSocialAccount: boolean,
          loyaltyDiscount: number,
          loyaltyCode: string,
          giftLoyaltyCredits: boolean,
        } | null,
        createdBy:  {
          name: string,
          id: string,
          email: string,
          isAdmin: boolean,
          isDriver: boolean,
          defaultLocale:  {
            id: string,
            label: string,
            mapLatitude: number,
            mapLongitude: number,
            countryCode: string,
          },
          isEmailVerified: boolean,
          invoiceTerms: number,
          isSocialAccount: boolean,
          loyaltyDiscount: number,
          loyaltyCode: string,
          giftLoyaltyCredits: boolean,
        },
        driver:  {
          id: string,
          booker:  {
            id: string,
          } | null,
          name: string,
        } | null,
        driverNotes: string,
        isConfirmed: boolean | null,
        isComplete: boolean,
        invoice:  {
          id: string,
          number: string,
          // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
          // Xero you can use this to check if it's null without fetching the Xero data.
          xeroInvoiceReady: boolean,
        } | null,
        isHidden: boolean,
        extraCharges:  Array< {
          amount: number,
          description: string,
          id: string,
          type: ExtraChargeType,
          invoice:  {
            id: string,
            number: string,
            // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
            // Xero you can use this to check if it's null without fetching the Xero data.
            xeroInvoiceReady: boolean,
          } | null,
        } >,
        automaticExtraCharges:  Array< {
          amount: number,
          description: string,
          type: ExtraChargeType,
        } >,
        stripeCard:  {
          id: string,
          last4: string | null,
          brand: CardBrandEnum | null,
          expiryYear: number | null,
          expiryMonth: number | null,
          bookerName: string,
          bookerId: string,
        } | null,
        paymentLink:  {
          toEmail: string,
          // I can't figure out right now whether it would be safe to expose the entire booker object here
          // so we're just exposing the booker ID for now.
          bookerId: string | null,
        } | null,
        promoCode: string | null,
        giftLoyaltyCredits: boolean,
        paidBy: BookingPaidBy,
      } >,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface BookingQueryVariables {
  id?: string | null,
  number?: string | null,
};

export interface BookingQuery {
  booking: ( {
      __typename: "Booking",
      id: string,
      number: string,
      bookingDate: string,
      bookingHour: number,
      bookingMinute: number,
      isCancelled: boolean,
      notes: string,
      passengerCount: number,
      babySeatsForward: number,
      babySeatsBackward: number,
      boosterSeats: number,
      wantPeopleMover: boolean,
      price:  {
        description: string,
        amount: number,
      } | null,
      status:  {
        bookingTimestamp: string,
        bookingDay7am: string,
        bookingDayBefore7pm: string,
      },
      journey:  {
        id: string,
        origin:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        destination:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        waypoints:  Array< {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        } >,
        distance: number | null,
        timeZoneId: string,
      },
      airportPickup:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      airportDropoff:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      passengers:  Array< {
        id: string,
        name: string,
        email: string | null,
        mobile: string | null,
        phone: string | null,
      } >,
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } | null,
      createdBy:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      },
      driver:  {
        id: string,
        booker:  {
          id: string,
        } | null,
        name: string,
      } | null,
      driverNotes: string,
      isConfirmed: boolean | null,
      isComplete: boolean,
      invoice:  {
        id: string,
        number: string,
        // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
        // Xero you can use this to check if it's null without fetching the Xero data.
        xeroInvoiceReady: boolean,
      } | null,
      isHidden: boolean,
      extraCharges:  Array< {
        amount: number,
        description: string,
        id: string,
        type: ExtraChargeType,
        invoice:  {
          id: string,
          number: string,
          // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
          // Xero you can use this to check if it's null without fetching the Xero data.
          xeroInvoiceReady: boolean,
        } | null,
      } >,
      automaticExtraCharges:  Array< {
        amount: number,
        description: string,
        type: ExtraChargeType,
      } >,
      stripeCard:  {
        id: string,
        last4: string | null,
        brand: CardBrandEnum | null,
        expiryYear: number | null,
        expiryMonth: number | null,
        bookerName: string,
        bookerId: string,
      } | null,
      paymentLink:  {
        toEmail: string,
        // I can't figure out right now whether it would be safe to expose the entire booker object here
        // so we're just exposing the booker ID for now.
        bookerId: string | null,
      } | null,
      promoCode: string | null,
      giftLoyaltyCredits: boolean,
      paidBy: BookingPaidBy,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface BookingPaymentLinkQueryVariables {
  secretId: string,
};

export interface BookingPaymentLinkQuery {
  bookingPaymentLink: ( {
      __typename: "BookingPaymentLink",
      bookingNumber: string,
      status: JobStatus | null,
      toEmail: string,
      // I can't figure out right now whether it would be safe to expose the entire booker object here
      // so we're just exposing the booker ID for now.
      bookerId: string | null,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface SubmitBookingMutationVariables {
  forBookerId?: string | null,
  details: BookingDetails,
  notes?: string | null,
  stripeCardId?: string | null,
  paymentLinkToEmail?: StringOrNull | null,
  promotion?: PromotionInput | null,
};

export interface SubmitBookingMutation {
  submitBooking: ( {
      __typename: "Booking",
      id: string,
      number: string,
      bookingDate: string,
      bookingHour: number,
      bookingMinute: number,
      isCancelled: boolean,
      notes: string,
      passengerCount: number,
      babySeatsForward: number,
      babySeatsBackward: number,
      boosterSeats: number,
      wantPeopleMover: boolean,
      price:  {
        description: string,
        amount: number,
      } | null,
      status:  {
        bookingTimestamp: string,
        bookingDay7am: string,
        bookingDayBefore7pm: string,
      },
      journey:  {
        id: string,
        origin:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        destination:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        waypoints:  Array< {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        } >,
        distance: number | null,
        timeZoneId: string,
      },
      airportPickup:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      airportDropoff:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      passengers:  Array< {
        id: string,
        name: string,
        email: string | null,
        mobile: string | null,
        phone: string | null,
      } >,
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } | null,
      createdBy:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      },
      driver:  {
        id: string,
        booker:  {
          id: string,
        } | null,
        name: string,
      } | null,
      driverNotes: string,
      isConfirmed: boolean | null,
      isComplete: boolean,
      invoice:  {
        id: string,
        number: string,
        // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
        // Xero you can use this to check if it's null without fetching the Xero data.
        xeroInvoiceReady: boolean,
      } | null,
      isHidden: boolean,
      extraCharges:  Array< {
        amount: number,
        description: string,
        id: string,
        type: ExtraChargeType,
        invoice:  {
          id: string,
          number: string,
          // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
          // Xero you can use this to check if it's null without fetching the Xero data.
          xeroInvoiceReady: boolean,
        } | null,
      } >,
      automaticExtraCharges:  Array< {
        amount: number,
        description: string,
        type: ExtraChargeType,
      } >,
      stripeCard:  {
        id: string,
        last4: string | null,
        brand: CardBrandEnum | null,
        expiryYear: number | null,
        expiryMonth: number | null,
        bookerName: string,
        bookerId: string,
      } | null,
      paymentLink:  {
        toEmail: string,
        // I can't figure out right now whether it would be safe to expose the entire booker object here
        // so we're just exposing the booker ID for now.
        bookerId: string | null,
      } | null,
      promoCode: string | null,
      giftLoyaltyCredits: boolean,
      paidBy: BookingPaidBy,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface SetBookingPromotionMutationVariables {
  id: string,
  promotion: PromotionInput,
};

export interface SetBookingPromotionMutation {
  setBookingPromotion: ( {
      __typename: "Booking",
      id: string,
      number: string,
      bookingDate: string,
      bookingHour: number,
      bookingMinute: number,
      isCancelled: boolean,
      notes: string,
      passengerCount: number,
      babySeatsForward: number,
      babySeatsBackward: number,
      boosterSeats: number,
      wantPeopleMover: boolean,
      price:  {
        description: string,
        amount: number,
      } | null,
      status:  {
        bookingTimestamp: string,
        bookingDay7am: string,
        bookingDayBefore7pm: string,
      },
      journey:  {
        id: string,
        origin:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        destination:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        waypoints:  Array< {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        } >,
        distance: number | null,
        timeZoneId: string,
      },
      airportPickup:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      airportDropoff:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      passengers:  Array< {
        id: string,
        name: string,
        email: string | null,
        mobile: string | null,
        phone: string | null,
      } >,
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } | null,
      createdBy:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      },
      driver:  {
        id: string,
        booker:  {
          id: string,
        } | null,
        name: string,
      } | null,
      driverNotes: string,
      isConfirmed: boolean | null,
      isComplete: boolean,
      invoice:  {
        id: string,
        number: string,
        // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
        // Xero you can use this to check if it's null without fetching the Xero data.
        xeroInvoiceReady: boolean,
      } | null,
      isHidden: boolean,
      extraCharges:  Array< {
        amount: number,
        description: string,
        id: string,
        type: ExtraChargeType,
        invoice:  {
          id: string,
          number: string,
          // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
          // Xero you can use this to check if it's null without fetching the Xero data.
          xeroInvoiceReady: boolean,
        } | null,
      } >,
      automaticExtraCharges:  Array< {
        amount: number,
        description: string,
        type: ExtraChargeType,
      } >,
      stripeCard:  {
        id: string,
        last4: string | null,
        brand: CardBrandEnum | null,
        expiryYear: number | null,
        expiryMonth: number | null,
        bookerName: string,
        bookerId: string,
      } | null,
      paymentLink:  {
        toEmail: string,
        // I can't figure out right now whether it would be safe to expose the entire booker object here
        // so we're just exposing the booker ID for now.
        bookerId: string | null,
      } | null,
      promoCode: string | null,
      giftLoyaltyCredits: boolean,
      paidBy: BookingPaidBy,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface SetBookingNotesMutationVariables {
  id: string,
  notes: string,
};

export interface SetBookingNotesMutation {
  setBookingNotes: ( {
      __typename: "Booking",
      id: string,
      number: string,
      bookingDate: string,
      bookingHour: number,
      bookingMinute: number,
      isCancelled: boolean,
      notes: string,
      passengerCount: number,
      babySeatsForward: number,
      babySeatsBackward: number,
      boosterSeats: number,
      wantPeopleMover: boolean,
      price:  {
        description: string,
        amount: number,
      } | null,
      status:  {
        bookingTimestamp: string,
        bookingDay7am: string,
        bookingDayBefore7pm: string,
      },
      journey:  {
        id: string,
        origin:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        destination:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        waypoints:  Array< {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        } >,
        distance: number | null,
        timeZoneId: string,
      },
      airportPickup:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      airportDropoff:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      passengers:  Array< {
        id: string,
        name: string,
        email: string | null,
        mobile: string | null,
        phone: string | null,
      } >,
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } | null,
      createdBy:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      },
      driver:  {
        id: string,
        booker:  {
          id: string,
        } | null,
        name: string,
      } | null,
      driverNotes: string,
      isConfirmed: boolean | null,
      isComplete: boolean,
      invoice:  {
        id: string,
        number: string,
        // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
        // Xero you can use this to check if it's null without fetching the Xero data.
        xeroInvoiceReady: boolean,
      } | null,
      isHidden: boolean,
      extraCharges:  Array< {
        amount: number,
        description: string,
        id: string,
        type: ExtraChargeType,
        invoice:  {
          id: string,
          number: string,
          // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
          // Xero you can use this to check if it's null without fetching the Xero data.
          xeroInvoiceReady: boolean,
        } | null,
      } >,
      automaticExtraCharges:  Array< {
        amount: number,
        description: string,
        type: ExtraChargeType,
      } >,
      stripeCard:  {
        id: string,
        last4: string | null,
        brand: CardBrandEnum | null,
        expiryYear: number | null,
        expiryMonth: number | null,
        bookerName: string,
        bookerId: string,
      } | null,
      paymentLink:  {
        toEmail: string,
        // I can't figure out right now whether it would be safe to expose the entire booker object here
        // so we're just exposing the booker ID for now.
        bookerId: string | null,
      } | null,
      promoCode: string | null,
      giftLoyaltyCredits: boolean,
      paidBy: BookingPaidBy,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface SetBookingDetailsMutationVariables {
  id: string,
  details: BookingDetails,
};

export interface SetBookingDetailsMutation {
  setBookingDetails: ( {
      __typename: "Booking",
      id: string,
      number: string,
      bookingDate: string,
      bookingHour: number,
      bookingMinute: number,
      isCancelled: boolean,
      notes: string,
      passengerCount: number,
      babySeatsForward: number,
      babySeatsBackward: number,
      boosterSeats: number,
      wantPeopleMover: boolean,
      price:  {
        description: string,
        amount: number,
      } | null,
      status:  {
        bookingTimestamp: string,
        bookingDay7am: string,
        bookingDayBefore7pm: string,
      },
      journey:  {
        id: string,
        origin:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        destination:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        waypoints:  Array< {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        } >,
        distance: number | null,
        timeZoneId: string,
      },
      airportPickup:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      airportDropoff:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      passengers:  Array< {
        id: string,
        name: string,
        email: string | null,
        mobile: string | null,
        phone: string | null,
      } >,
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } | null,
      createdBy:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      },
      driver:  {
        id: string,
        booker:  {
          id: string,
        } | null,
        name: string,
      } | null,
      driverNotes: string,
      isConfirmed: boolean | null,
      isComplete: boolean,
      invoice:  {
        id: string,
        number: string,
        // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
        // Xero you can use this to check if it's null without fetching the Xero data.
        xeroInvoiceReady: boolean,
      } | null,
      isHidden: boolean,
      extraCharges:  Array< {
        amount: number,
        description: string,
        id: string,
        type: ExtraChargeType,
        invoice:  {
          id: string,
          number: string,
          // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
          // Xero you can use this to check if it's null without fetching the Xero data.
          xeroInvoiceReady: boolean,
        } | null,
      } >,
      automaticExtraCharges:  Array< {
        amount: number,
        description: string,
        type: ExtraChargeType,
      } >,
      stripeCard:  {
        id: string,
        last4: string | null,
        brand: CardBrandEnum | null,
        expiryYear: number | null,
        expiryMonth: number | null,
        bookerName: string,
        bookerId: string,
      } | null,
      paymentLink:  {
        toEmail: string,
        // I can't figure out right now whether it would be safe to expose the entire booker object here
        // so we're just exposing the booker ID for now.
        bookerId: string | null,
      } | null,
      promoCode: string | null,
      giftLoyaltyCredits: boolean,
      paidBy: BookingPaidBy,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface SetBookingDriverMutationVariables {
  id: string,
  driverId?: string | null,
};

export interface SetBookingDriverMutation {
  setBookingDriver: ( {
      __typename: "Booking",
      id: string,
      number: string,
      bookingDate: string,
      bookingHour: number,
      bookingMinute: number,
      isCancelled: boolean,
      notes: string,
      passengerCount: number,
      babySeatsForward: number,
      babySeatsBackward: number,
      boosterSeats: number,
      wantPeopleMover: boolean,
      price:  {
        description: string,
        amount: number,
      } | null,
      status:  {
        bookingTimestamp: string,
        bookingDay7am: string,
        bookingDayBefore7pm: string,
      },
      journey:  {
        id: string,
        origin:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        destination:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        waypoints:  Array< {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        } >,
        distance: number | null,
        timeZoneId: string,
      },
      airportPickup:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      airportDropoff:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      passengers:  Array< {
        id: string,
        name: string,
        email: string | null,
        mobile: string | null,
        phone: string | null,
      } >,
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } | null,
      createdBy:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      },
      driver:  {
        id: string,
        booker:  {
          id: string,
        } | null,
        name: string,
      } | null,
      driverNotes: string,
      isConfirmed: boolean | null,
      isComplete: boolean,
      invoice:  {
        id: string,
        number: string,
        // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
        // Xero you can use this to check if it's null without fetching the Xero data.
        xeroInvoiceReady: boolean,
      } | null,
      isHidden: boolean,
      extraCharges:  Array< {
        amount: number,
        description: string,
        id: string,
        type: ExtraChargeType,
        invoice:  {
          id: string,
          number: string,
          // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
          // Xero you can use this to check if it's null without fetching the Xero data.
          xeroInvoiceReady: boolean,
        } | null,
      } >,
      automaticExtraCharges:  Array< {
        amount: number,
        description: string,
        type: ExtraChargeType,
      } >,
      stripeCard:  {
        id: string,
        last4: string | null,
        brand: CardBrandEnum | null,
        expiryYear: number | null,
        expiryMonth: number | null,
        bookerName: string,
        bookerId: string,
      } | null,
      paymentLink:  {
        toEmail: string,
        // I can't figure out right now whether it would be safe to expose the entire booker object here
        // so we're just exposing the booker ID for now.
        bookerId: string | null,
      } | null,
      promoCode: string | null,
      giftLoyaltyCredits: boolean,
      paidBy: BookingPaidBy,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface SetBookingBookerMutationVariables {
  id: string,
  bookerId?: string | null,
};

export interface SetBookingBookerMutation {
  setBookingBooker: ( {
      __typename: "Booking",
      id: string,
      number: string,
      bookingDate: string,
      bookingHour: number,
      bookingMinute: number,
      isCancelled: boolean,
      notes: string,
      passengerCount: number,
      babySeatsForward: number,
      babySeatsBackward: number,
      boosterSeats: number,
      wantPeopleMover: boolean,
      price:  {
        description: string,
        amount: number,
      } | null,
      status:  {
        bookingTimestamp: string,
        bookingDay7am: string,
        bookingDayBefore7pm: string,
      },
      journey:  {
        id: string,
        origin:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        destination:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        waypoints:  Array< {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        } >,
        distance: number | null,
        timeZoneId: string,
      },
      airportPickup:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      airportDropoff:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      passengers:  Array< {
        id: string,
        name: string,
        email: string | null,
        mobile: string | null,
        phone: string | null,
      } >,
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } | null,
      createdBy:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      },
      driver:  {
        id: string,
        booker:  {
          id: string,
        } | null,
        name: string,
      } | null,
      driverNotes: string,
      isConfirmed: boolean | null,
      isComplete: boolean,
      invoice:  {
        id: string,
        number: string,
        // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
        // Xero you can use this to check if it's null without fetching the Xero data.
        xeroInvoiceReady: boolean,
      } | null,
      isHidden: boolean,
      extraCharges:  Array< {
        amount: number,
        description: string,
        id: string,
        type: ExtraChargeType,
        invoice:  {
          id: string,
          number: string,
          // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
          // Xero you can use this to check if it's null without fetching the Xero data.
          xeroInvoiceReady: boolean,
        } | null,
      } >,
      automaticExtraCharges:  Array< {
        amount: number,
        description: string,
        type: ExtraChargeType,
      } >,
      stripeCard:  {
        id: string,
        last4: string | null,
        brand: CardBrandEnum | null,
        expiryYear: number | null,
        expiryMonth: number | null,
        bookerName: string,
        bookerId: string,
      } | null,
      paymentLink:  {
        toEmail: string,
        // I can't figure out right now whether it would be safe to expose the entire booker object here
        // so we're just exposing the booker ID for now.
        bookerId: string | null,
      } | null,
      promoCode: string | null,
      giftLoyaltyCredits: boolean,
      paidBy: BookingPaidBy,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface SetBookingPriceMutationVariables {
  id: string,
  price?: OptionalCharge | null,
  extraCharges?: Array< ExtraChargeInput > | null,
};

export interface SetBookingPriceMutation {
  setBookingPrice: ( {
      __typename: "Booking",
      id: string,
      number: string,
      bookingDate: string,
      bookingHour: number,
      bookingMinute: number,
      isCancelled: boolean,
      notes: string,
      passengerCount: number,
      babySeatsForward: number,
      babySeatsBackward: number,
      boosterSeats: number,
      wantPeopleMover: boolean,
      price:  {
        description: string,
        amount: number,
      } | null,
      status:  {
        bookingTimestamp: string,
        bookingDay7am: string,
        bookingDayBefore7pm: string,
      },
      journey:  {
        id: string,
        origin:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        destination:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        waypoints:  Array< {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        } >,
        distance: number | null,
        timeZoneId: string,
      },
      airportPickup:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      airportDropoff:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      passengers:  Array< {
        id: string,
        name: string,
        email: string | null,
        mobile: string | null,
        phone: string | null,
      } >,
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } | null,
      createdBy:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      },
      driver:  {
        id: string,
        booker:  {
          id: string,
        } | null,
        name: string,
      } | null,
      driverNotes: string,
      isConfirmed: boolean | null,
      isComplete: boolean,
      invoice:  {
        id: string,
        number: string,
        // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
        // Xero you can use this to check if it's null without fetching the Xero data.
        xeroInvoiceReady: boolean,
      } | null,
      isHidden: boolean,
      extraCharges:  Array< {
        amount: number,
        description: string,
        id: string,
        type: ExtraChargeType,
        invoice:  {
          id: string,
          number: string,
          // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
          // Xero you can use this to check if it's null without fetching the Xero data.
          xeroInvoiceReady: boolean,
        } | null,
      } >,
      automaticExtraCharges:  Array< {
        amount: number,
        description: string,
        type: ExtraChargeType,
      } >,
      stripeCard:  {
        id: string,
        last4: string | null,
        brand: CardBrandEnum | null,
        expiryYear: number | null,
        expiryMonth: number | null,
        bookerName: string,
        bookerId: string,
      } | null,
      paymentLink:  {
        toEmail: string,
        // I can't figure out right now whether it would be safe to expose the entire booker object here
        // so we're just exposing the booker ID for now.
        bookerId: string | null,
      } | null,
      promoCode: string | null,
      giftLoyaltyCredits: boolean,
      paidBy: BookingPaidBy,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface SetPaymentDetailsMutationVariables {
  id: string,
  stripeCardId?: UUIDOrNull | null,
  paymentLinkToEmail?: StringOrNull | null,
  paidBy?: BookingPaidBy | null,
};

export interface SetPaymentDetailsMutation {
  setPaymentDetails: ( {
      __typename: "Booking",
      id: string,
      number: string,
      bookingDate: string,
      bookingHour: number,
      bookingMinute: number,
      isCancelled: boolean,
      notes: string,
      passengerCount: number,
      babySeatsForward: number,
      babySeatsBackward: number,
      boosterSeats: number,
      wantPeopleMover: boolean,
      price:  {
        description: string,
        amount: number,
      } | null,
      status:  {
        bookingTimestamp: string,
        bookingDay7am: string,
        bookingDayBefore7pm: string,
      },
      journey:  {
        id: string,
        origin:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        destination:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        waypoints:  Array< {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        } >,
        distance: number | null,
        timeZoneId: string,
      },
      airportPickup:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      airportDropoff:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      passengers:  Array< {
        id: string,
        name: string,
        email: string | null,
        mobile: string | null,
        phone: string | null,
      } >,
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } | null,
      createdBy:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      },
      driver:  {
        id: string,
        booker:  {
          id: string,
        } | null,
        name: string,
      } | null,
      driverNotes: string,
      isConfirmed: boolean | null,
      isComplete: boolean,
      invoice:  {
        id: string,
        number: string,
        // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
        // Xero you can use this to check if it's null without fetching the Xero data.
        xeroInvoiceReady: boolean,
      } | null,
      isHidden: boolean,
      extraCharges:  Array< {
        amount: number,
        description: string,
        id: string,
        type: ExtraChargeType,
        invoice:  {
          id: string,
          number: string,
          // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
          // Xero you can use this to check if it's null without fetching the Xero data.
          xeroInvoiceReady: boolean,
        } | null,
      } >,
      automaticExtraCharges:  Array< {
        amount: number,
        description: string,
        type: ExtraChargeType,
      } >,
      stripeCard:  {
        id: string,
        last4: string | null,
        brand: CardBrandEnum | null,
        expiryYear: number | null,
        expiryMonth: number | null,
        bookerName: string,
        bookerId: string,
      } | null,
      paymentLink:  {
        toEmail: string,
        // I can't figure out right now whether it would be safe to expose the entire booker object here
        // so we're just exposing the booker ID for now.
        bookerId: string | null,
      } | null,
      promoCode: string | null,
      giftLoyaltyCredits: boolean,
      paidBy: BookingPaidBy,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface BookingDriverUpdateMutationVariables {
  id: string,
  driverUpdate: DriverUpdate,
};

export interface BookingDriverUpdateMutation {
  bookingDriverUpdate: ( {
      __typename: "Booking",
      id: string,
      number: string,
      bookingDate: string,
      bookingHour: number,
      bookingMinute: number,
      isCancelled: boolean,
      notes: string,
      passengerCount: number,
      babySeatsForward: number,
      babySeatsBackward: number,
      boosterSeats: number,
      wantPeopleMover: boolean,
      price:  {
        description: string,
        amount: number,
      } | null,
      status:  {
        bookingTimestamp: string,
        bookingDay7am: string,
        bookingDayBefore7pm: string,
      },
      journey:  {
        id: string,
        origin:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        destination:  {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        },
        waypoints:  Array< {
          id: string,
          googlePlaceId: string,
          optionalName: string | null,
          address: string,
          type: PlaceType,
          category: PlaceCategory,
          isAirportStop: boolean,
        } >,
        distance: number | null,
        timeZoneId: string,
      },
      airportPickup:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      airportDropoff:  {
        id: string,
        airlineCode: string,
        flightType: FlightTypeEnum,
        flightNumber: string,
      } | null,
      passengers:  Array< {
        id: string,
        name: string,
        email: string | null,
        mobile: string | null,
        phone: string | null,
      } >,
      booker:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      } | null,
      createdBy:  {
        name: string,
        id: string,
        email: string,
        isAdmin: boolean,
        isDriver: boolean,
        defaultLocale:  {
          id: string,
          label: string,
          mapLatitude: number,
          mapLongitude: number,
          countryCode: string,
        },
        isEmailVerified: boolean,
        invoiceTerms: number,
        isSocialAccount: boolean,
        loyaltyDiscount: number,
        loyaltyCode: string,
        giftLoyaltyCredits: boolean,
      },
      driver:  {
        id: string,
        booker:  {
          id: string,
        } | null,
        name: string,
      } | null,
      driverNotes: string,
      isConfirmed: boolean | null,
      isComplete: boolean,
      invoice:  {
        id: string,
        number: string,
        // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
        // Xero you can use this to check if it's null without fetching the Xero data.
        xeroInvoiceReady: boolean,
      } | null,
      isHidden: boolean,
      extraCharges:  Array< {
        amount: number,
        description: string,
        id: string,
        type: ExtraChargeType,
        invoice:  {
          id: string,
          number: string,
          // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
          // Xero you can use this to check if it's null without fetching the Xero data.
          xeroInvoiceReady: boolean,
        } | null,
      } >,
      automaticExtraCharges:  Array< {
        amount: number,
        description: string,
        type: ExtraChargeType,
      } >,
      stripeCard:  {
        id: string,
        last4: string | null,
        brand: CardBrandEnum | null,
        expiryYear: number | null,
        expiryMonth: number | null,
        bookerName: string,
        bookerId: string,
      } | null,
      paymentLink:  {
        toEmail: string,
        // I can't figure out right now whether it would be safe to expose the entire booker object here
        // so we're just exposing the booker ID for now.
        bookerId: string | null,
      } | null,
      promoCode: string | null,
      giftLoyaltyCredits: boolean,
      paidBy: BookingPaidBy,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface UseBookingPaymentLinkMutationVariables {
  secretId: string,
};

export interface UseBookingPaymentLinkMutation {
  useBookingPaymentLink:  {
    message: string,
    // The value of this is meaningless. It's just here because this type is used as a union with
    // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
    // https://github.com/apollographql/apollo-client/issues/2510
    // It also has to be a UUID rather than a dumb String or Int because you can't select a field
    // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
    // another type in the union. :(
    id: string,
  } | null,
};

export interface BookingsQueryVariables {
  filter?: BookingsFilter | null,
  seek?: BookingsSeek | null,
};

export interface BookingsQuery {
  bookings: ( {
      __typename: "BookingsResult",
      // The seek to use to get the next page (if there is a next page)
      next:  {
        bookingDateTime: string,
        bookingId: string,
        direction: PageDirection,
      } | null,
      // The seek to use to get the previous page (if there is a previous page)
      prev:  {
        bookingDateTime: string,
        bookingId: string,
        direction: PageDirection,
      } | null,
      bookings:  Array< {
        id: string,
        number: string,
        bookingDateTime: string,
        state: BookingState | null,
        nettPrice: number | null,
        paidBy: BookingPaidBy,
        isComplete: boolean,
        isCancelled: boolean,
        driver:  {
          id: string,
          name: string,
        } | null,
        isImminent: boolean,
        isConfirmed: boolean | null,
        journey:  {
          id: string,
          origin:  {
            id: string,
            googlePlaceId: string,
            optionalName: string | null,
            address: string,
            type: PlaceType,
            category: PlaceCategory,
            isAirportStop: boolean,
          },
          destination:  {
            id: string,
            googlePlaceId: string,
            optionalName: string | null,
            address: string,
            type: PlaceType,
            category: PlaceCategory,
            isAirportStop: boolean,
          },
          timeZoneId: string,
        },
        airportPickup:  {
          id: string,
          airlineCode: string,
          flightType: FlightTypeEnum,
          flightNumber: string,
        } | null,
        airportDropoff:  {
          id: string,
          airlineCode: string,
          flightType: FlightTypeEnum,
          flightNumber: string,
        } | null,
        passengers:  Array< {
          id: string,
          name: string,
        } >,
        booker:  {
          id: string,
          email: string,
          name: string,
        } | null,
      } >,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface BookingStatusQueryVariables {
  bookingDateTime: string,
  originId?: string | null,
};

export interface BookingStatusQuery {
  bookingStatus:  {
    bookingTimestamp: string,
    bookingDay7am: string,
    bookingDayBefore7pm: string,
  } | null,
};

export interface BookingsSummaryQuery {
  bookingsSummary: ( {
      __typename: "BookingsSummaryResult",
      summary:  Array< {
        timeZoneId: string,
        year: number,
        month: number,
        completed: number,
      } >,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface ChargesQueryVariables {
  details: BookingDetails,
  journeyId: string,
  bookingId?: string | null
};

export interface ChargesQuery {
  charges:  {
    total:  {
      description: string,
      amount: number,
    },
    items:  Array< {
      type: ChargeType,
      amount: number,
    } > | null,
  } | null,
};

export interface LoyaltyProgramDiscountQueryVariables {
  bookingDateTime: string,
  journeyId: string,
  forBookerId?: string | null,
  bookingId?: string | null,
  promoCode: string,
  giftLoyaltyCredits?: boolean | null,
};

export interface LoyaltyProgramDiscountQuery {
  loyaltyProgramDiscount: ( {
      __typename: "LoyaltyProgramDiscount",
      initial: boolean,
      referrer:  {
        amount: number,
        description: string,
        type: ExtraChargeType,
      } | null,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface CommonPlacesQuery {
  commonPlaces:  Array< {
    id: string,
    placeId: string,
    locale:  {
      id: string,
      label: string,
      mapLatitude: number,
      mapLongitude: number,
      countryCode: string,
    },
    label: string,
    shortLabel: string,
    suggest: boolean,
    category: PlaceCategory,
  } >,
};

export interface DefaultLocaleQueryVariables {
  id?: string | null,
};

export interface DefaultLocaleQuery {
  defaultLocale:  {
    id: string,
    label: string,
    mapLatitude: number,
    mapLongitude: number,
    countryCode: string,
  },
};

export interface DeleteCommonPlaceMutationVariables {
  id: string,
};

export interface DeleteCommonPlaceMutation {
  deleteCommonPlace: ( {
      __typename: "UUIDObj",
      uuid: string,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface DeletePlaceNicknameMutationVariables {
  id: string,
};

export interface DeletePlaceNicknameMutation {
  deletePlaceNickname: ( {
      __typename: "UUIDObj",
      uuid: string,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface EnsureJourneyQueryVariables {
  journey: JourneyInput,
};

export interface EnsureJourneyQuery {
  ensureJourney:  {
    id: string,
    origin:  {
      id: string,
      googlePlaceId: string,
      optionalName: string | null,
      address: string,
      type: PlaceType,
      category: PlaceCategory,
      isAirportStop: boolean,
    },
    destination:  {
      id: string,
      googlePlaceId: string,
      optionalName: string | null,
      address: string,
      type: PlaceType,
      category: PlaceCategory,
      isAirportStop: boolean,
    },
    waypoints:  Array< {
      id: string,
      googlePlaceId: string,
      optionalName: string | null,
      address: string,
      type: PlaceType,
      category: PlaceCategory,
      isAirportStop: boolean,
    } >,
    distance: number | null,
    timeZoneId: string,
  },
};

export interface JourneyQueryVariables {
  id: string,
};

export interface JourneyQuery {
  journey: ( {
      __typename: "Journey",
      id: string,
      origin:  {
        id: string,
        googlePlaceId: string,
        optionalName: string | null,
        address: string,
        type: PlaceType,
        category: PlaceCategory,
        isAirportStop: boolean,
      },
      destination:  {
        id: string,
        googlePlaceId: string,
        optionalName: string | null,
        address: string,
        type: PlaceType,
        category: PlaceCategory,
        isAirportStop: boolean,
      },
      waypoints:  Array< {
        id: string,
        googlePlaceId: string,
        optionalName: string | null,
        address: string,
        type: PlaceType,
        category: PlaceCategory,
        isAirportStop: boolean,
      } >,
      distance: number | null,
      timeZoneId: string,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface UpdateJourneyMutationVariables {
  id: string,
  distance?: number | null,
};

export interface UpdateJourneyMutation {
  updateJourney: ( {
      __typename: "Journey",
      id: string,
      origin:  {
        id: string,
        googlePlaceId: string,
        optionalName: string | null,
        address: string,
        type: PlaceType,
        category: PlaceCategory,
        isAirportStop: boolean,
      },
      destination:  {
        id: string,
        googlePlaceId: string,
        optionalName: string | null,
        address: string,
        type: PlaceType,
        category: PlaceCategory,
        isAirportStop: boolean,
      },
      waypoints:  Array< {
        id: string,
        googlePlaceId: string,
        optionalName: string | null,
        address: string,
        type: PlaceType,
        category: PlaceCategory,
        isAirportStop: boolean,
      } >,
      distance: number | null,
      timeZoneId: string,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface LocalesQuery {
  locales:  Array< {
    id: string,
    label: string,
    mapLatitude: number,
    mapLongitude: number,
    countryCode: string,
  } >,
};

export interface PastPassengersQueryVariables {
  forBookerId?: string | null,
};

export interface PastPassengersQuery {
  pastPassengers:  Array< {
    count: string | null,
    name: string,
    email: string | null,
    mobile: string | null,
    phone: string | null,
  } >,
};

export interface PlaceQueryVariables {
  id: string,
};

export interface PlaceQuery {
  place:  {
    id: string,
    googlePlaceId: string,
    optionalName: string | null,
    address: string,
    type: PlaceType,
    category: PlaceCategory,
    isAirportStop: boolean,
  },
};

export interface PlaceNicknamesQuery {
  placeNicknames:  Array< {
    id: string,
    label: string,
  } >,
};

export interface PlaceSuggestQueryVariables {
  localeId: string,
  text: string,
  raw?: boolean | null,
};

export interface PlaceSuggestQuery {
  placeSuggestions:  Array< {
    id: string,
    googlePlaceId: string,
    optionalName: string | null,
    address: string,
    type: PlaceType,
    category: PlaceCategory,
    isAirportStop: boolean,
  } >,
};

export interface CreateStripeCardMutationVariables {
  token: string,
  forBookerId: string,
};

export interface CreateStripeCardMutation {
  createStripeCard: ( {
      __typename: "UUIDObj",
      uuid: string,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface StripeCardQueryVariables {
  id: string,
};

export interface StripeCardQuery {
  stripeCard: ( {
      __typename: "StripeCardOrNull",
      stripeCard:  {
        id: string,
        last4: string | null,
        brand: CardBrandEnum | null,
        expiryYear: number | null,
        expiryMonth: number | null,
        bookerName: string,
        bookerId: string,
      } | null,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface StripeCardsQueryVariables {
  forBookerId: string,
};

export interface StripeCardsQuery {
  stripeCards: ( {
      __typename: "StripeCards",
      stripeCards:  Array< {
        id: string,
        last4: string | null,
        brand: CardBrandEnum | null,
        expiryYear: number | null,
        expiryMonth: number | null,
        bookerName: string,
        bookerId: string,
      } >,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface StripeConfigQuery {
  stripeConfig:  {
    publicKey: string,
  },
};

export interface XeroInvoiceQueryVariables {
  id: string,
};

export interface XeroInvoiceQuery {
  xeroInvoice:  {
    id: string,
    contact:  {
      email: string | null,
      name: string,
    },
    number: string,
    paid: number,
    owing: number,
    total: number,
    xeroUuid: string,
  },
};

export interface InvoiceByNumberQueryVariables {
  number: string,
};

export interface InvoiceByNumberQuery {
  invoiceByNumber: ( {
      __typename: "Invoice",
      id: string,
      number: string,
      // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
      // Xero you can use this to check if it's null without fetching the Xero data.
      xeroInvoiceReady: boolean,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface CreateStripeChargeMutationVariables {
  invoiceId: string,
  stripeToken: string,
  amountCents: number,
};

export interface CreateStripeChargeMutation {
  createStripeCharge:  {
    __typename: "StripeCharge",
    id: string,
    isComplete: boolean,
    isFailed: boolean,
    failedMessage: string | null,
  },
};

export interface StripeChargeQueryVariables {
  id: string,
};

export interface StripeChargeQuery {
  stripeCharge:  {
    __typename: "StripeCharge",
    id: string,
    isComplete: boolean,
    isFailed: boolean,
    failedMessage: string | null,
  },
};

export interface ResendInvoiceMutationVariables {
  invoiceId: string,
};

export interface ResendInvoiceMutation {
  resendInvoice: ( {
      __typename: "SendInvoiceJob",
      id: string,
      isComplete: boolean,
      isFailed: boolean,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface ResendInvoiceStatusQueryVariables {
  id: string,
};

export interface ResendInvoiceStatusQuery {
  resendInvoiceStatus: ( {
      __typename: "SendInvoiceJob",
      id: string,
      isComplete: boolean,
      isFailed: boolean,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface UpsertCommonPlaceMutationVariables {
  commonPlace: CommonPlaceInput,
};

export interface UpsertCommonPlaceMutation {
  upsertCommonPlace: ( {
      id: string,
      placeId: string,
      locale:  {
        id: string,
        label: string,
        mapLatitude: number,
        mapLongitude: number,
        countryCode: string,
      },
      label: string,
      shortLabel: string,
      suggest: boolean,
      category: PlaceCategory,
      __typename: "CommonPlace",
    } | {
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
      __typename: "Error",
    }
  ),
};

export interface UpsertPlaceNicknameMutationVariables {
  id: string,
  label: string,
};

export interface UpsertPlaceNicknameMutation {
  upsertPlaceNickname: ( {
      __typename: "PlaceNickname",
      id: string,
      label: string,
    } | {
      __typename: "Error",
      message: string,
      // The value of this is meaningless. It's just here because this type is used as a union with
      // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
      // https://github.com/apollographql/apollo-client/issues/2510
      // It also has to be a UUID rather than a dumb String or Int because you can't select a field
      // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
      // another type in the union. :(
      id: string,
    }
  ),
};

export interface BecomeDriverMutationVariables {
  driverSmsId: string,
};

export interface BecomeDriverMutation {
  becomeDriver:  {
    __typename: "Error",
    message: string,
    // The value of this is meaningless. It's just here because this type is used as a union with
    // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
    // https://github.com/apollographql/apollo-client/issues/2510
    // It also has to be a UUID rather than a dumb String or Int because you can't select a field
    // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
    // another type in the union. :(
    id: string,
  } | null,
};

export interface AirlineFragment {
  id: string,
  name: string,
};

export interface AirportStopFragment {
  id: string,
  airlineCode: string,
  flightType: FlightTypeEnum,
  flightNumber: string,
};

export interface Auth0ConfigFragFragment {
  // Do not add clientSecret here!
  domain: string,
  clientId: string,
  loginCallbackUrl: string,
  logoutUrl: string,
  nonce: string,
};

export interface BookerFragFragment {
  name: string,
  id: string,
  email: string,
  isAdmin: boolean,
  isDriver: boolean,
  defaultLocale:  {
    id: string,
    label: string,
    mapLatitude: number,
    mapLongitude: number,
    countryCode: string,
  },
  isEmailVerified: boolean,
  invoiceTerms: number,
  isSocialAccount: boolean,
  loyaltyDiscount: number,
  loyaltyCode: string,
  giftLoyaltyCredits: boolean,
};

export interface BookerProfileFragFragment {
  name: string,
  id: string,
  email: string,
  isAdmin: boolean,
  isDriver: boolean,
  defaultLocale:  {
    id: string,
    label: string,
    mapLatitude: number,
    mapLongitude: number,
    countryCode: string,
  },
  isEmailVerified: boolean,
  invoiceTerms: number,
  isSocialAccount: boolean,
  loyaltyDiscount: number,
  loyaltyCode: string,
  giftLoyaltyCredits: boolean,
  accountsEmail: string,
  address:  {
    attention: string,
    address: string,
    suburb: string,
    postCode: string,
    state: string,
    country: string,
  },
};

export interface DriverFragment {
  id: string,
  booker:  {
    name: string,
    id: string,
    email: string,
    isAdmin: boolean,
    isDriver: boolean,
    defaultLocale:  {
      id: string,
      label: string,
      mapLatitude: number,
      mapLongitude: number,
      countryCode: string,
    },
    isEmailVerified: boolean,
    invoiceTerms: number,
    isSocialAccount: boolean,
    loyaltyDiscount: number,
    loyaltyCode: string,
    giftLoyaltyCredits: boolean,
  } | null,
  name: string,
  mobileNumber: string,
  active: boolean,
};

export interface BasicDriverFragment {
  id: string,
  booker:  {
    id: string,
  } | null,
  name: string,
};

export interface InvoiceFragment {
  id: string,
  number: string,
  // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
  // Xero you can use this to check if it's null without fetching the Xero data.
  xeroInvoiceReady: boolean,
};

export interface ExtraChargeFragment {
  amount: number,
  description: string,
  id: string,
  type: ExtraChargeType,
  invoice:  {
    id: string,
    number: string,
    // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
    // Xero you can use this to check if it's null without fetching the Xero data.
    xeroInvoiceReady: boolean,
  } | null,
};

export interface AutomaticExtraChargeFragment {
  amount: number,
  description: string,
  type: ExtraChargeType,
};

export interface BookingGutsFragment {
  id: string,
  number: string,
  bookingDate: string,
  bookingHour: number,
  bookingMinute: number,
  isCancelled: boolean,
  notes: string,
  passengerCount: number,
  babySeatsForward: number,
  babySeatsBackward: number,
  boosterSeats: number,
  wantPeopleMover: boolean,
  price:  {
    description: string,
    amount: number,
  } | null,
  status:  {
    bookingTimestamp: string,
    bookingDay7am: string,
    bookingDayBefore7pm: string,
  },
  journey:  {
    id: string,
    origin:  {
      id: string,
      googlePlaceId: string,
      optionalName: string | null,
      address: string,
      type: PlaceType,
      category: PlaceCategory,
      isAirportStop: boolean,
    },
    destination:  {
      id: string,
      googlePlaceId: string,
      optionalName: string | null,
      address: string,
      type: PlaceType,
      category: PlaceCategory,
      isAirportStop: boolean,
    },
    waypoints:  Array< {
      id: string,
      googlePlaceId: string,
      optionalName: string | null,
      address: string,
      type: PlaceType,
      category: PlaceCategory,
      isAirportStop: boolean,
    } >,
    distance: number | null,
    timeZoneId: string,
  },
  airportPickup:  {
    id: string,
    airlineCode: string,
    flightType: FlightTypeEnum,
    flightNumber: string,
  } | null,
  airportDropoff:  {
    id: string,
    airlineCode: string,
    flightType: FlightTypeEnum,
    flightNumber: string,
  } | null,
  passengers:  Array< {
    id: string,
    name: string,
    email: string | null,
    mobile: string | null,
    phone: string | null,
  } >,
  booker:  {
    name: string,
    id: string,
    email: string,
    isAdmin: boolean,
    isDriver: boolean,
    defaultLocale:  {
      id: string,
      label: string,
      mapLatitude: number,
      mapLongitude: number,
      countryCode: string,
    },
    isEmailVerified: boolean,
    invoiceTerms: number,
    isSocialAccount: boolean,
    loyaltyDiscount: number,
    loyaltyCode: string,
    giftLoyaltyCredits: boolean,
  } | null,
  createdBy:  {
    name: string,
    id: string,
    email: string,
    isAdmin: boolean,
    isDriver: boolean,
    defaultLocale:  {
      id: string,
      label: string,
      mapLatitude: number,
      mapLongitude: number,
      countryCode: string,
    },
    isEmailVerified: boolean,
    invoiceTerms: number,
    isSocialAccount: boolean,
    loyaltyDiscount: number,
    loyaltyCode: string,
    giftLoyaltyCredits: boolean,
  },
  driver:  {
    id: string,
    booker:  {
      id: string,
    } | null,
    name: string,
  } | null,
  driverNotes: string,
  isConfirmed: boolean | null,
  isComplete: boolean,
  invoice:  {
    id: string,
    number: string,
    // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
    // Xero you can use this to check if it's null without fetching the Xero data.
    xeroInvoiceReady: boolean,
  } | null,
  isHidden: boolean,
  extraCharges:  Array< {
    amount: number,
    description: string,
    id: string,
    type: ExtraChargeType,
    invoice:  {
      id: string,
      number: string,
      // Whether or not the `xeroInvoice` field is not null. Since that field contains data from
      // Xero you can use this to check if it's null without fetching the Xero data.
      xeroInvoiceReady: boolean,
    } | null,
  } >,
  automaticExtraCharges:  Array< {
    amount: number,
    description: string,
    type: ExtraChargeType,
  } >,
  stripeCard:  {
    id: string,
    last4: string | null,
    brand: CardBrandEnum | null,
    expiryYear: number | null,
    expiryMonth: number | null,
    bookerName: string,
    bookerId: string,
  } | null,
  paymentLink:  {
    toEmail: string,
    // I can't figure out right now whether it would be safe to expose the entire booker object here
    // so we're just exposing the booker ID for now.
    bookerId: string | null,
  } | null,
  promoCode: string | null,
  giftLoyaltyCredits: boolean,
  paidBy: BookingPaidBy,
};

export interface PaymentLinkFragment {
  bookingNumber: string,
  status: JobStatus | null,
  toEmail: string,
  // I can't figure out right now whether it would be safe to expose the entire booker object here
  // so we're just exposing the booker ID for now.
  bookerId: string | null,
};

export interface StripeCardFragment {
  id: string,
  last4: string | null,
  brand: CardBrandEnum | null,
  expiryYear: number | null,
  expiryMonth: number | null,
  bookerName: string,
  bookerId: string,
};

export interface BookingListItemFragment {
  id: string,
  number: string,
  bookingDateTime: string,
  state: BookingState | null,
  nettPrice: number | null,
  paidBy: BookingPaidBy,
  isComplete: boolean,
  isCancelled: boolean,
  driver:  {
    id: string,
    name: string,
  } | null,
  isImminent: boolean,
  isConfirmed: boolean | null,
  journey:  {
    id: string,
    origin:  {
      id: string,
      googlePlaceId: string,
      optionalName: string | null,
      address: string,
      type: PlaceType,
      category: PlaceCategory,
      isAirportStop: boolean,
    },
    destination:  {
      id: string,
      googlePlaceId: string,
      optionalName: string | null,
      address: string,
      type: PlaceType,
      category: PlaceCategory,
      isAirportStop: boolean,
    },
    timeZoneId: string,
  },
  airportPickup:  {
    id: string,
    airlineCode: string,
    flightType: FlightTypeEnum,
    flightNumber: string,
  } | null,
  airportDropoff:  {
    id: string,
    airlineCode: string,
    flightType: FlightTypeEnum,
    flightNumber: string,
  } | null,
  passengers:  Array< {
    id: string,
    name: string,
  } >,
  booker:  {
    id: string,
    email: string,
    name: string,
  } | null,
};

export interface BookingsSeekFragment {
  bookingDateTime: string,
  bookingId: string,
  direction: PageDirection,
};

export interface BookingsResultFragment {
  // The seek to use to get the next page (if there is a next page)
  next:  {
    bookingDateTime: string,
    bookingId: string,
    direction: PageDirection,
  } | null,
  // The seek to use to get the previous page (if there is a previous page)
  prev:  {
    bookingDateTime: string,
    bookingId: string,
    direction: PageDirection,
  } | null,
  bookings:  Array< {
    id: string,
    number: string,
    bookingDateTime: string,
    state: BookingState | null,
    nettPrice: number | null,
    paidBy: BookingPaidBy,
    isComplete: boolean,
    isCancelled: boolean,
    driver:  {
      id: string,
      name: string,
    } | null,
    isImminent: boolean,
    isConfirmed: boolean | null,
    journey:  {
      id: string,
      origin:  {
        id: string,
        googlePlaceId: string,
        optionalName: string | null,
        address: string,
        type: PlaceType,
        category: PlaceCategory,
        isAirportStop: boolean,
      },
      destination:  {
        id: string,
        googlePlaceId: string,
        optionalName: string | null,
        address: string,
        type: PlaceType,
        category: PlaceCategory,
        isAirportStop: boolean,
      },
      timeZoneId: string,
    },
    airportPickup:  {
      id: string,
      airlineCode: string,
      flightType: FlightTypeEnum,
      flightNumber: string,
    } | null,
    airportDropoff:  {
      id: string,
      airlineCode: string,
      flightType: FlightTypeEnum,
      flightNumber: string,
    } | null,
    passengers:  Array< {
      id: string,
      name: string,
    } >,
    booker:  {
      id: string,
      email: string,
      name: string,
    } | null,
  } >,
};

export interface BookingStatusFragment {
  bookingTimestamp: string,
  bookingDay7am: string,
  bookingDayBefore7pm: string,
};

export interface BookingsSummaryFragment {
  timeZoneId: string,
  year: number,
  month: number,
  completed: number,
};

export interface BookingsSummaryResultFragment {
  summary:  Array< {
    timeZoneId: string,
    year: number,
    month: number,
    completed: number,
  } >,
};

export interface ChargeFragment {
  description: string,
  amount: number,
};

export interface ChargeItemFragment {
  type: ChargeType,
  amount: number,
};

export interface ChargesFragment {
  total:  {
    description: string,
    amount: number,
  },
  items:  Array< {
    type: ChargeType,
    amount: number,
  } > | null,
};

export interface LoyaltyProgramDiscountFragment {
  initial: boolean,
  referrer:  {
    amount: number,
    description: string,
    type: ExtraChargeType,
  } | null,
};

export interface CommonPlaceFragment {
  id: string,
  placeId: string,
  locale:  {
    id: string,
    label: string,
    mapLatitude: number,
    mapLongitude: number,
    countryCode: string,
  },
  label: string,
  shortLabel: string,
  suggest: boolean,
  category: PlaceCategory,
};

export interface UUIDObjFragment {
  uuid: string,
};

export interface JourneyFragment {
  id: string,
  origin:  {
    id: string,
    googlePlaceId: string,
    optionalName: string | null,
    address: string,
    type: PlaceType,
    category: PlaceCategory,
    isAirportStop: boolean,
  },
  destination:  {
    id: string,
    googlePlaceId: string,
    optionalName: string | null,
    address: string,
    type: PlaceType,
    category: PlaceCategory,
    isAirportStop: boolean,
  },
  waypoints:  Array< {
    id: string,
    googlePlaceId: string,
    optionalName: string | null,
    address: string,
    type: PlaceType,
    category: PlaceCategory,
    isAirportStop: boolean,
  } >,
  distance: number | null,
  timeZoneId: string,
};

export interface LocaleFragment {
  id: string,
  label: string,
  mapLatitude: number,
  mapLongitude: number,
  countryCode: string,
};

export interface PassengerFragment {
  id: string,
  name: string,
  email: string | null,
  mobile: string | null,
  phone: string | null,
};

export interface PastPassengerFragment {
  count: string | null,
  name: string,
  email: string | null,
  mobile: string | null,
  phone: string | null,
};

export interface PlaceFragment {
  id: string,
  googlePlaceId: string,
  optionalName: string | null,
  address: string,
  type: PlaceType,
  category: PlaceCategory,
  isAirportStop: boolean,
};

export interface PlaceNicknameFragment {
  id: string,
  label: string,
};

export interface StripeChargeFragFragment {
  __typename: "StripeCharge",
  id: string,
  isComplete: boolean,
  isFailed: boolean,
  failedMessage: string | null,
};

export interface SendInvoiceJobFragment {
  id: string,
  isComplete: boolean,
  isFailed: boolean,
};

export interface ErrorFragment {
  message: string,
  // The value of this is meaningless. It's just here because this type is used as a union with
  // types that have IDs, and Apollo doesn't like it if only some types in a union have IDs. See:
  // https://github.com/apollographql/apollo-client/issues/2510
  // It also has to be a UUID rather than a dumb String or Int because you can't select a field
  // called "id" as a String or Int for one type in a union and a field called "id" as a UUID for
  // another type in the union. :(
  id: string,
};

import {default as gql_} from "graphql-tag"
import {DocumentNode} from "graphql"

export class Operation<Targs, Tresult> {
  constructor(public document: DocumentNode) {}
  run(args: Targs, run: (document: DocumentNode, args: any) => Promise<any>): Promise<Tresult> {
    return run(this.document, args);
  }
}
export class Query<In, Out> extends Operation<In, Out> {}
export class Mutation<In, Out> extends Operation<In, Out> {}
export class Subscription<In, Out> extends Operation<In, Out> {}


export const AirportAirlines = new Query<AirportAirlinesQueryVariables, AirportAirlinesQuery>(gql_`
query AirportAirlines($airportPlaceId: UUID!) {
  airportAirlines(airportPlaceId: $airportPlaceId) {
    ...Airline
  }
}
fragment Airline on Airline {
  id
  name
}
`);

export const ShowTestModeBand = new Query<{}, ShowTestModeBandQuery>(gql_`
query ShowTestModeBand {
  showTestModeBand
}
`);

export const Auth0Config = new Query<{}, Auth0ConfigQuery>(gql_`
query Auth0Config {
  auth0Config {
    ...Auth0ConfigFrag
  }
}
fragment Auth0ConfigFrag on Auth0Config {
  domain
  clientId
  loginCallbackUrl
  logoutUrl
  nonce
}
`);

export const Booker = new Query<{}, BookerQuery>(gql_`
query Booker {
  booker {
    __typename
    ...Error
    ... on BookerOrNull {
      booker {
        ...BookerFrag
      }
    }
  }
}
fragment Error on Error {
  message
  id
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
`);

export const BookerByNewBookerSecret = new Query<BookerByNewBookerSecretQueryVariables, BookerByNewBookerSecretQuery>(gql_`
query BookerByNewBookerSecret($secret: UUID!) {
  bookerByNewBookerSecret(secret: $secret) {
    ...BookerFrag
  }
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
`);

export const BookerProfileData = new Query<BookerProfileDataQueryVariables, BookerProfileDataQuery>(gql_`
query BookerProfileData($forBookerId: UUID) {
  booker(forBookerId: $forBookerId) {
    __typename
    ...Error
    ... on BookerOrNull {
      booker {
        ...BookerProfileFrag
      }
    }
  }
}
fragment Error on Error {
  message
  id
}
fragment BookerProfileFrag on Booker {
  ...BookerFrag
  accountsEmail
  address {
    attention
    address
    suburb
    postCode
    state
    country
  }
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
`);

export const CreateBooker = new Mutation<CreateBookerMutationVariables, CreateBookerMutation>(gql_`
mutation CreateBooker($name: String, $email: String!, $matchByEmail: Boolean) {
  createBooker(name: $name, email: $email, matchByEmail: $matchByEmail) {
    __typename
    ...Error
    ...BookerFrag
  }
}
fragment Error on Error {
  message
  id
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
`);

export const UpdateBooker = new Mutation<UpdateBookerMutationVariables, UpdateBookerMutation>(gql_`
mutation UpdateBooker($forBookerId: UUID!, $booker: BookerInput!) {
  updateBooker(forBookerId: $forBookerId, booker: $booker) {
    __typename
    ...Error
    ...BookerProfileFrag
  }
}
fragment Error on Error {
  message
  id
}
fragment BookerProfileFrag on Booker {
  ...BookerFrag
  accountsEmail
  address {
    attention
    address
    suburb
    postCode
    state
    country
  }
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
`);

export const Bookers = new Query<BookersQueryVariables, BookersQuery>(gql_`
query Bookers($searchTerm: String) {
  bookers(searchTerm: $searchTerm) {
    __typename
    ...Error
    ... on Bookers {
      bookers {
        ...BookerFrag
      }
    }
  }
}
fragment Error on Error {
  message
  id
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
`);

export const Drivers = new Query<DriversQueryVariables, DriversQuery>(gql_`
query Drivers($active: Boolean) {
  drivers(active: $active) {
    __typename
    ...Error
    ... on Drivers {
      drivers {
        ...Driver
      }
    }
  }
}
fragment Error on Error {
  message
  id
}
fragment Driver on Driver {
  id
  booker {
    ...BookerFrag
  }
  name
  mobileNumber
  active
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
`);

export const UpsertDriver = new Mutation<UpsertDriverMutationVariables, UpsertDriverMutation>(gql_`
mutation UpsertDriver($id: UUID, $driver: DriverInput!) {
  upsertDriver(id: $id, driver: $driver) {
    __typename
    ...Error
    ...Driver
  }
}
fragment Error on Error {
  message
  id
}
fragment Driver on Driver {
  id
  booker {
    ...BookerFrag
  }
  name
  mobileNumber
  active
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
`);

export const BasicDrivers = new Query<BasicDriversQueryVariables, BasicDriversQuery>(gql_`
query BasicDrivers($active: Boolean) {
  drivers(active: $active) {
    __typename
    ...Error
    ... on Drivers {
      drivers {
        ...BasicDriver
      }
    }
  }
}
fragment Error on Error {
  message
  id
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
`);

export const CancelBooking = new Mutation<CancelBookingMutationVariables, CancelBookingMutation>(gql_`
mutation CancelBooking($id: UUID!) {
  cancelBooking(id: $id) {
    __typename
    ...Error
    ...BookingGuts
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingGuts on Booking {
  id
  number
  bookingDate
  bookingHour
  bookingMinute
  isCancelled
  notes
  passengerCount
  babySeatsForward
  babySeatsBackward
  boosterSeats
  wantPeopleMover
  price {
    ...Charge
  }
  status {
    ...BookingStatus
  }
  journey {
    ...Journey
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    ...Passenger
  }
  booker {
    ...BookerFrag
  }
  createdBy {
    ...BookerFrag
  }
  driver {
    ...BasicDriver
  }
  driverNotes
  isConfirmed
  isComplete
  invoice {
    ...Invoice
  }
  isHidden
  extraCharges {
    ...ExtraCharge
  }
  automaticExtraCharges {
    ...AutomaticExtraCharge
  }
  stripeCard {
    ...StripeCard
  }
  paymentLink {
    toEmail
    bookerId
  }
  promoCode
  giftLoyaltyCredits
  paidBy
}
fragment Charge on Charge {
  description
  amount
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
fragment Passenger on Passenger {
  id
  name
  email
  mobile
  phone
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
fragment ExtraCharge on ExtraCharge {
  amount
  description
  id
  type
  invoice {
    ...Invoice
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const UncancelBooking = new Mutation<UncancelBookingMutationVariables, UncancelBookingMutation>(gql_`
mutation UncancelBooking($id: UUID!) {
  uncancelBooking(id: $id) {
    __typename
    ...Error
    ...BookingGuts
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingGuts on Booking {
  id
  number
  bookingDate
  bookingHour
  bookingMinute
  isCancelled
  notes
  passengerCount
  babySeatsForward
  babySeatsBackward
  boosterSeats
  wantPeopleMover
  price {
    ...Charge
  }
  status {
    ...BookingStatus
  }
  journey {
    ...Journey
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    ...Passenger
  }
  booker {
    ...BookerFrag
  }
  createdBy {
    ...BookerFrag
  }
  driver {
    ...BasicDriver
  }
  driverNotes
  isConfirmed
  isComplete
  invoice {
    ...Invoice
  }
  isHidden
  extraCharges {
    ...ExtraCharge
  }
  automaticExtraCharges {
    ...AutomaticExtraCharge
  }
  stripeCard {
    ...StripeCard
  }
  paymentLink {
    toEmail
    bookerId
  }
  promoCode
  giftLoyaltyCredits
  paidBy
}
fragment Charge on Charge {
  description
  amount
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
fragment Passenger on Passenger {
  id
  name
  email
  mobile
  phone
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
fragment ExtraCharge on ExtraCharge {
  amount
  description
  id
  type
  invoice {
    ...Invoice
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const ResendBookingEmail = new Mutation<ResendBookingEmailMutationVariables, ResendBookingEmailMutation>(gql_`
mutation ResendBookingEmail($id: UUID!) {
  resendBookingEmail(id: $id) {
    __typename
    ...Error
  }
}
fragment Error on Error {
  message
  id
}
`);

export const InvoiceBookings = new Mutation<InvoiceBookingsMutationVariables, InvoiceBookingsMutation>(gql_`
mutation InvoiceBookings($ids: [UUID!]!) {
  invoiceBookings(ids: $ids) {
    __typename
    ...Error
    ... on Bookings {
      bookings {
        ...BookingGuts
      }
    }
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingGuts on Booking {
  id
  number
  bookingDate
  bookingHour
  bookingMinute
  isCancelled
  notes
  passengerCount
  babySeatsForward
  babySeatsBackward
  boosterSeats
  wantPeopleMover
  price {
    ...Charge
  }
  status {
    ...BookingStatus
  }
  journey {
    ...Journey
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    ...Passenger
  }
  booker {
    ...BookerFrag
  }
  createdBy {
    ...BookerFrag
  }
  driver {
    ...BasicDriver
  }
  driverNotes
  isConfirmed
  isComplete
  invoice {
    ...Invoice
  }
  isHidden
  extraCharges {
    ...ExtraCharge
  }
  automaticExtraCharges {
    ...AutomaticExtraCharge
  }
  stripeCard {
    ...StripeCard
  }
  paymentLink {
    toEmail
    bookerId
  }
  promoCode
  giftLoyaltyCredits
  paidBy
}
fragment Charge on Charge {
  description
  amount
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
fragment Passenger on Passenger {
  id
  name
  email
  mobile
  phone
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
fragment ExtraCharge on ExtraCharge {
  amount
  description
  id
  type
  invoice {
    ...Invoice
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const SetBookingsHidden = new Mutation<SetBookingsHiddenMutationVariables, SetBookingsHiddenMutation>(gql_`
mutation SetBookingsHidden($ids: [UUID!]!, $hidden: Boolean!) {
  setBookingsHidden(ids: $ids, hidden: $hidden) {
    __typename
    ...Error
    ... on Bookings {
      bookings {
        ...BookingGuts
      }
    }
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingGuts on Booking {
  id
  number
  bookingDate
  bookingHour
  bookingMinute
  isCancelled
  notes
  passengerCount
  babySeatsForward
  babySeatsBackward
  boosterSeats
  wantPeopleMover
  price {
    ...Charge
  }
  status {
    ...BookingStatus
  }
  journey {
    ...Journey
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    ...Passenger
  }
  booker {
    ...BookerFrag
  }
  createdBy {
    ...BookerFrag
  }
  driver {
    ...BasicDriver
  }
  driverNotes
  isConfirmed
  isComplete
  invoice {
    ...Invoice
  }
  isHidden
  extraCharges {
    ...ExtraCharge
  }
  automaticExtraCharges {
    ...AutomaticExtraCharge
  }
  stripeCard {
    ...StripeCard
  }
  paymentLink {
    toEmail
    bookerId
  }
  promoCode
  giftLoyaltyCredits
  paidBy
}
fragment Charge on Charge {
  description
  amount
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
fragment Passenger on Passenger {
  id
  name
  email
  mobile
  phone
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
fragment ExtraCharge on ExtraCharge {
  amount
  description
  id
  type
  invoice {
    ...Invoice
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const Booking = new Query<BookingQueryVariables, BookingQuery>(gql_`
query Booking($id: UUID, $number: String) {
  booking(id: $id, number: $number) {
    __typename
    ...Error
    ...BookingGuts
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingGuts on Booking {
  id
  number
  bookingDate
  bookingHour
  bookingMinute
  isCancelled
  notes
  passengerCount
  babySeatsForward
  babySeatsBackward
  boosterSeats
  wantPeopleMover
  price {
    ...Charge
  }
  status {
    ...BookingStatus
  }
  journey {
    ...Journey
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    ...Passenger
  }
  booker {
    ...BookerFrag
  }
  createdBy {
    ...BookerFrag
  }
  driver {
    ...BasicDriver
  }
  driverNotes
  isConfirmed
  isComplete
  invoice {
    ...Invoice
  }
  isHidden
  extraCharges {
    ...ExtraCharge
  }
  automaticExtraCharges {
    ...AutomaticExtraCharge
  }
  stripeCard {
    ...StripeCard
  }
  paymentLink {
    toEmail
    bookerId
  }
  promoCode
  giftLoyaltyCredits
  paidBy
}
fragment Charge on Charge {
  description
  amount
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
fragment Passenger on Passenger {
  id
  name
  email
  mobile
  phone
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
fragment ExtraCharge on ExtraCharge {
  amount
  description
  id
  type
  invoice {
    ...Invoice
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const BookingPaymentLink = new Query<BookingPaymentLinkQueryVariables, BookingPaymentLinkQuery>(gql_`
query BookingPaymentLink($secretId: UUID!) {
  bookingPaymentLink(secretId: $secretId) {
    __typename
    ...Error
    ...PaymentLink
  }
}
fragment Error on Error {
  message
  id
}
fragment PaymentLink on BookingPaymentLink {
  bookingNumber
  status
  toEmail
  bookerId
}
`);

export const SubmitBooking = new Mutation<SubmitBookingMutationVariables, SubmitBookingMutation>(gql_`
mutation SubmitBooking($forBookerId: UUID, $details: BookingDetails!, $notes: String, $stripeCardId: UUID, $paymentLinkToEmail: StringOrNull, $promotion: PromotionInput) {
  submitBooking(forBookerId: $forBookerId, details: $details, notes: $notes, stripeCardId: $stripeCardId, paymentLinkToEmail: $paymentLinkToEmail, promotion: $promotion) {
    __typename
    ...Error
    ...BookingGuts
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingGuts on Booking {
  id
  number
  bookingDate
  bookingHour
  bookingMinute
  isCancelled
  notes
  passengerCount
  babySeatsForward
  babySeatsBackward
  boosterSeats
  wantPeopleMover
  price {
    ...Charge
  }
  status {
    ...BookingStatus
  }
  journey {
    ...Journey
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    ...Passenger
  }
  booker {
    ...BookerFrag
  }
  createdBy {
    ...BookerFrag
  }
  driver {
    ...BasicDriver
  }
  driverNotes
  isConfirmed
  isComplete
  invoice {
    ...Invoice
  }
  isHidden
  extraCharges {
    ...ExtraCharge
  }
  automaticExtraCharges {
    ...AutomaticExtraCharge
  }
  stripeCard {
    ...StripeCard
  }
  paymentLink {
    toEmail
    bookerId
  }
  promoCode
  giftLoyaltyCredits
  paidBy
}
fragment Charge on Charge {
  description
  amount
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
fragment Passenger on Passenger {
  id
  name
  email
  mobile
  phone
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
fragment ExtraCharge on ExtraCharge {
  amount
  description
  id
  type
  invoice {
    ...Invoice
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const SetBookingPromotion = new Mutation<SetBookingPromotionMutationVariables, SetBookingPromotionMutation>(gql_`
mutation SetBookingPromotion($id: UUID!, $promotion: PromotionInput!) {
  setBookingPromotion(id: $id, promotion: $promotion) {
    __typename
    ...Error
    ...BookingGuts
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingGuts on Booking {
  id
  number
  bookingDate
  bookingHour
  bookingMinute
  isCancelled
  notes
  passengerCount
  babySeatsForward
  babySeatsBackward
  boosterSeats
  wantPeopleMover
  price {
    ...Charge
  }
  status {
    ...BookingStatus
  }
  journey {
    ...Journey
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    ...Passenger
  }
  booker {
    ...BookerFrag
  }
  createdBy {
    ...BookerFrag
  }
  driver {
    ...BasicDriver
  }
  driverNotes
  isConfirmed
  isComplete
  invoice {
    ...Invoice
  }
  isHidden
  extraCharges {
    ...ExtraCharge
  }
  automaticExtraCharges {
    ...AutomaticExtraCharge
  }
  stripeCard {
    ...StripeCard
  }
  paymentLink {
    toEmail
    bookerId
  }
  promoCode
  giftLoyaltyCredits
  paidBy
}
fragment Charge on Charge {
  description
  amount
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
fragment Passenger on Passenger {
  id
  name
  email
  mobile
  phone
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
fragment ExtraCharge on ExtraCharge {
  amount
  description
  id
  type
  invoice {
    ...Invoice
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const SetBookingNotes = new Mutation<SetBookingNotesMutationVariables, SetBookingNotesMutation>(gql_`
mutation SetBookingNotes($id: UUID!, $notes: String!) {
  setBookingNotes(id: $id, notes: $notes) {
    __typename
    ...Error
    ...BookingGuts
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingGuts on Booking {
  id
  number
  bookingDate
  bookingHour
  bookingMinute
  isCancelled
  notes
  passengerCount
  babySeatsForward
  babySeatsBackward
  boosterSeats
  wantPeopleMover
  price {
    ...Charge
  }
  status {
    ...BookingStatus
  }
  journey {
    ...Journey
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    ...Passenger
  }
  booker {
    ...BookerFrag
  }
  createdBy {
    ...BookerFrag
  }
  driver {
    ...BasicDriver
  }
  driverNotes
  isConfirmed
  isComplete
  invoice {
    ...Invoice
  }
  isHidden
  extraCharges {
    ...ExtraCharge
  }
  automaticExtraCharges {
    ...AutomaticExtraCharge
  }
  stripeCard {
    ...StripeCard
  }
  paymentLink {
    toEmail
    bookerId
  }
  promoCode
  giftLoyaltyCredits
  paidBy
}
fragment Charge on Charge {
  description
  amount
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
fragment Passenger on Passenger {
  id
  name
  email
  mobile
  phone
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
fragment ExtraCharge on ExtraCharge {
  amount
  description
  id
  type
  invoice {
    ...Invoice
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const SetBookingDetails = new Mutation<SetBookingDetailsMutationVariables, SetBookingDetailsMutation>(gql_`
mutation SetBookingDetails($id: UUID!, $details: BookingDetails!) {
  setBookingDetails(id: $id, details: $details) {
    __typename
    ...Error
    ...BookingGuts
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingGuts on Booking {
  id
  number
  bookingDate
  bookingHour
  bookingMinute
  isCancelled
  notes
  passengerCount
  babySeatsForward
  babySeatsBackward
  boosterSeats
  wantPeopleMover
  price {
    ...Charge
  }
  status {
    ...BookingStatus
  }
  journey {
    ...Journey
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    ...Passenger
  }
  booker {
    ...BookerFrag
  }
  createdBy {
    ...BookerFrag
  }
  driver {
    ...BasicDriver
  }
  driverNotes
  isConfirmed
  isComplete
  invoice {
    ...Invoice
  }
  isHidden
  extraCharges {
    ...ExtraCharge
  }
  automaticExtraCharges {
    ...AutomaticExtraCharge
  }
  stripeCard {
    ...StripeCard
  }
  paymentLink {
    toEmail
    bookerId
  }
  promoCode
  giftLoyaltyCredits
  paidBy
}
fragment Charge on Charge {
  description
  amount
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
fragment Passenger on Passenger {
  id
  name
  email
  mobile
  phone
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
fragment ExtraCharge on ExtraCharge {
  amount
  description
  id
  type
  invoice {
    ...Invoice
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const SetBookingDriver = new Mutation<SetBookingDriverMutationVariables, SetBookingDriverMutation>(gql_`
mutation SetBookingDriver($id: UUID!, $driverId: UUID) {
  setBookingDriver(id: $id, driverId: $driverId) {
    __typename
    ...Error
    ...BookingGuts
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingGuts on Booking {
  id
  number
  bookingDate
  bookingHour
  bookingMinute
  isCancelled
  notes
  passengerCount
  babySeatsForward
  babySeatsBackward
  boosterSeats
  wantPeopleMover
  price {
    ...Charge
  }
  status {
    ...BookingStatus
  }
  journey {
    ...Journey
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    ...Passenger
  }
  booker {
    ...BookerFrag
  }
  createdBy {
    ...BookerFrag
  }
  driver {
    ...BasicDriver
  }
  driverNotes
  isConfirmed
  isComplete
  invoice {
    ...Invoice
  }
  isHidden
  extraCharges {
    ...ExtraCharge
  }
  automaticExtraCharges {
    ...AutomaticExtraCharge
  }
  stripeCard {
    ...StripeCard
  }
  paymentLink {
    toEmail
    bookerId
  }
  promoCode
  giftLoyaltyCredits
  paidBy
}
fragment Charge on Charge {
  description
  amount
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
fragment Passenger on Passenger {
  id
  name
  email
  mobile
  phone
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
fragment ExtraCharge on ExtraCharge {
  amount
  description
  id
  type
  invoice {
    ...Invoice
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const SetBookingBooker = new Mutation<SetBookingBookerMutationVariables, SetBookingBookerMutation>(gql_`
mutation SetBookingBooker($id: UUID!, $bookerId: UUID) {
  setBookingBooker(id: $id, bookerId: $bookerId) {
    __typename
    ...Error
    ...BookingGuts
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingGuts on Booking {
  id
  number
  bookingDate
  bookingHour
  bookingMinute
  isCancelled
  notes
  passengerCount
  babySeatsForward
  babySeatsBackward
  boosterSeats
  wantPeopleMover
  price {
    ...Charge
  }
  status {
    ...BookingStatus
  }
  journey {
    ...Journey
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    ...Passenger
  }
  booker {
    ...BookerFrag
  }
  createdBy {
    ...BookerFrag
  }
  driver {
    ...BasicDriver
  }
  driverNotes
  isConfirmed
  isComplete
  invoice {
    ...Invoice
  }
  isHidden
  extraCharges {
    ...ExtraCharge
  }
  automaticExtraCharges {
    ...AutomaticExtraCharge
  }
  stripeCard {
    ...StripeCard
  }
  paymentLink {
    toEmail
    bookerId
  }
  promoCode
  giftLoyaltyCredits
  paidBy
}
fragment Charge on Charge {
  description
  amount
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
fragment Passenger on Passenger {
  id
  name
  email
  mobile
  phone
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
fragment ExtraCharge on ExtraCharge {
  amount
  description
  id
  type
  invoice {
    ...Invoice
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const SetBookingPrice = new Mutation<SetBookingPriceMutationVariables, SetBookingPriceMutation>(gql_`
mutation SetBookingPrice($id: UUID!, $price: OptionalCharge, $extraCharges: [ExtraChargeInput!]) {
  setBookingPrice(id: $id, price: $price, extraCharges: $extraCharges) {
    __typename
    ...Error
    ...BookingGuts
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingGuts on Booking {
  id
  number
  bookingDate
  bookingHour
  bookingMinute
  isCancelled
  notes
  passengerCount
  babySeatsForward
  babySeatsBackward
  boosterSeats
  wantPeopleMover
  price {
    ...Charge
  }
  status {
    ...BookingStatus
  }
  journey {
    ...Journey
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    ...Passenger
  }
  booker {
    ...BookerFrag
  }
  createdBy {
    ...BookerFrag
  }
  driver {
    ...BasicDriver
  }
  driverNotes
  isConfirmed
  isComplete
  invoice {
    ...Invoice
  }
  isHidden
  extraCharges {
    ...ExtraCharge
  }
  automaticExtraCharges {
    ...AutomaticExtraCharge
  }
  stripeCard {
    ...StripeCard
  }
  paymentLink {
    toEmail
    bookerId
  }
  promoCode
  giftLoyaltyCredits
  paidBy
}
fragment Charge on Charge {
  description
  amount
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
fragment Passenger on Passenger {
  id
  name
  email
  mobile
  phone
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
fragment ExtraCharge on ExtraCharge {
  amount
  description
  id
  type
  invoice {
    ...Invoice
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const SetPaymentDetails = new Mutation<SetPaymentDetailsMutationVariables, SetPaymentDetailsMutation>(gql_`
mutation SetPaymentDetails($id: UUID!, $stripeCardId: UUIDOrNull, $paymentLinkToEmail: StringOrNull, $paidBy: BookingPaidBy) {
  setPaymentDetails(id: $id, stripeCardId: $stripeCardId, paymentLinkToEmail: $paymentLinkToEmail, paidBy: $paidBy) {
    __typename
    ...Error
    ...BookingGuts
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingGuts on Booking {
  id
  number
  bookingDate
  bookingHour
  bookingMinute
  isCancelled
  notes
  passengerCount
  babySeatsForward
  babySeatsBackward
  boosterSeats
  wantPeopleMover
  price {
    ...Charge
  }
  status {
    ...BookingStatus
  }
  journey {
    ...Journey
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    ...Passenger
  }
  booker {
    ...BookerFrag
  }
  createdBy {
    ...BookerFrag
  }
  driver {
    ...BasicDriver
  }
  driverNotes
  isConfirmed
  isComplete
  invoice {
    ...Invoice
  }
  isHidden
  extraCharges {
    ...ExtraCharge
  }
  automaticExtraCharges {
    ...AutomaticExtraCharge
  }
  stripeCard {
    ...StripeCard
  }
  paymentLink {
    toEmail
    bookerId
  }
  promoCode
  giftLoyaltyCredits
  paidBy
}
fragment Charge on Charge {
  description
  amount
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
fragment Passenger on Passenger {
  id
  name
  email
  mobile
  phone
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
fragment ExtraCharge on ExtraCharge {
  amount
  description
  id
  type
  invoice {
    ...Invoice
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const BookingDriverUpdate = new Mutation<BookingDriverUpdateMutationVariables, BookingDriverUpdateMutation>(gql_`
mutation BookingDriverUpdate($id: UUID!, $driverUpdate: DriverUpdate!) {
  bookingDriverUpdate(id: $id, driverUpdate: $driverUpdate) {
    __typename
    ...Error
    ...BookingGuts
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingGuts on Booking {
  id
  number
  bookingDate
  bookingHour
  bookingMinute
  isCancelled
  notes
  passengerCount
  babySeatsForward
  babySeatsBackward
  boosterSeats
  wantPeopleMover
  price {
    ...Charge
  }
  status {
    ...BookingStatus
  }
  journey {
    ...Journey
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    ...Passenger
  }
  booker {
    ...BookerFrag
  }
  createdBy {
    ...BookerFrag
  }
  driver {
    ...BasicDriver
  }
  driverNotes
  isConfirmed
  isComplete
  invoice {
    ...Invoice
  }
  isHidden
  extraCharges {
    ...ExtraCharge
  }
  automaticExtraCharges {
    ...AutomaticExtraCharge
  }
  stripeCard {
    ...StripeCard
  }
  paymentLink {
    toEmail
    bookerId
  }
  promoCode
  giftLoyaltyCredits
  paidBy
}
fragment Charge on Charge {
  description
  amount
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
fragment Passenger on Passenger {
  id
  name
  email
  mobile
  phone
}
fragment BookerFrag on Booker {
  name
  id
  email
  isAdmin
  isDriver
  defaultLocale {
    ...Locale
  }
  isEmailVerified
  invoiceTerms
  isSocialAccount
  loyaltyDiscount
  loyaltyCode
  giftLoyaltyCredits
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment BasicDriver on Driver {
  id
  booker {
    id
  }
  name
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
fragment ExtraCharge on ExtraCharge {
  amount
  description
  id
  type
  invoice {
    ...Invoice
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const UseBookingPaymentLink = new Mutation<UseBookingPaymentLinkMutationVariables, UseBookingPaymentLinkMutation>(gql_`
mutation UseBookingPaymentLink($secretId: UUID!) {
  useBookingPaymentLink(secretId: $secretId) {
    ...Error
  }
}
fragment Error on Error {
  message
  id
}
`);

export const Bookings = new Query<BookingsQueryVariables, BookingsQuery>(gql_`
query Bookings($filter: BookingsFilter, $seek: BookingsSeek) {
  bookings(filter: $filter, seek: $seek) {
    __typename
    ...Error
    ...BookingsResult
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingsResult on BookingsResult {
  next {
    ...BookingsSeek
  }
  prev {
    ...BookingsSeek
  }
  bookings {
    ...BookingListItem
  }
}
fragment BookingsSeek on BookingsSeekOut {
  bookingDateTime
  bookingId
  direction
}
fragment BookingListItem on Booking {
  id
  number
  bookingDateTime
  state
  nettPrice
  paidBy
  isComplete
  isCancelled
  driver {
    id
    name
  }
  isImminent
  isConfirmed
  journey {
    id
    origin {
      ...Place
    }
    destination {
      ...Place
    }
    timeZoneId
  }
  airportPickup {
    ...AirportStop
  }
  airportDropoff {
    ...AirportStop
  }
  passengers {
    id
    name
  }
  booker {
    id
    email
    name
  }
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
fragment AirportStop on AirportStop {
  id
  airlineCode
  flightType
  flightNumber
}
`);

export const BookingStatus = new Query<BookingStatusQueryVariables, BookingStatusQuery>(gql_`
query BookingStatus($bookingDateTime: LocalDateTime!, $originId: UUID) {
  bookingStatus(bookingDateTime: $bookingDateTime, originId: $originId) {
    ...BookingStatus
  }
}
fragment BookingStatus on BookingStatus {
  bookingTimestamp
  bookingDay7am
  bookingDayBefore7pm
}
`);

export const BookingsSummary = new Query<{}, BookingsSummaryQuery>(gql_`
query BookingsSummary {
  bookingsSummary {
    __typename
    ...Error
    ...BookingsSummaryResult
  }
}
fragment Error on Error {
  message
  id
}
fragment BookingsSummaryResult on BookingsSummaryResult {
  summary {
    ...BookingsSummary
  }
}
fragment BookingsSummary on BookingsSummary {
  timeZoneId
  year
  month
  completed
}
`);

export const Charges = new Query<ChargesQueryVariables, ChargesQuery>(gql_`
query Charges($details: BookingDetails!, $journeyId: UUID!, $bookingId: UUID) {
  charges(details: $details, journeyId: $journeyId, bookingId: $bookingId) {
    ...Charges
  }
}
fragment Charges on Charges {
  total {
    ...Charge
  }
  items {
    ...ChargeItem
  }
}
fragment Charge on Charge {
  description
  amount
}
fragment ChargeItem on ChargeItem {
  type
  amount
}
`);

export const LoyaltyProgramDiscount = new Query<LoyaltyProgramDiscountQueryVariables, LoyaltyProgramDiscountQuery>(gql_`
query LoyaltyProgramDiscount($bookingDateTime: LocalDateTime!, $journeyId: UUID!, $forBookerId: UUID, $bookingId: UUID, $promoCode: String!, $giftLoyaltyCredits: Boolean) {
  loyaltyProgramDiscount(bookingDateTime: $bookingDateTime, journeyId: $journeyId, forBookerId: $forBookerId, bookingId: $bookingId, promoCode: $promoCode, giftLoyaltyCredits: $giftLoyaltyCredits) {
    __typename
    ...Error
    ...LoyaltyProgramDiscount
  }
}
fragment Error on Error {
  message
  id
}
fragment LoyaltyProgramDiscount on LoyaltyProgramDiscount {
  initial
  referrer {
    ...AutomaticExtraCharge
  }
}
fragment AutomaticExtraCharge on AutomaticExtraCharge {
  amount
  description
  type
}
`);

export const CommonPlaces = new Query<{}, CommonPlacesQuery>(gql_`
query CommonPlaces {
  commonPlaces {
    ...CommonPlace
  }
}
fragment CommonPlace on CommonPlace {
  id
  placeId
  locale {
    ...Locale
  }
  label
  shortLabel
  suggest
  category
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
`);

export const DefaultLocale = new Query<DefaultLocaleQueryVariables, DefaultLocaleQuery>(gql_`
query DefaultLocale($id: UUID) {
  defaultLocale(localeId: $id) {
    ...Locale
  }
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
`);

export const DeleteCommonPlace = new Mutation<DeleteCommonPlaceMutationVariables, DeleteCommonPlaceMutation>(gql_`
mutation DeleteCommonPlace($id: UUID!) {
  deleteCommonPlace(id: $id) {
    __typename
    ...Error
    ...UUIDObj
  }
}
fragment Error on Error {
  message
  id
}
fragment UUIDObj on UUIDObj {
  uuid
}
`);

export const DeletePlaceNickname = new Mutation<DeletePlaceNicknameMutationVariables, DeletePlaceNicknameMutation>(gql_`
mutation DeletePlaceNickname($id: UUID!) {
  deletePlaceNickname(id: $id) {
    __typename
    ...Error
    ...UUIDObj
  }
}
fragment Error on Error {
  message
  id
}
fragment UUIDObj on UUIDObj {
  uuid
}
`);

export const EnsureJourney = new Query<EnsureJourneyQueryVariables, EnsureJourneyQuery>(gql_`
query EnsureJourney($journey: JourneyInput!) {
  ensureJourney(journey: $journey) {
    ...Journey
  }
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
`);

export const Journey = new Query<JourneyQueryVariables, JourneyQuery>(gql_`
query Journey($id: UUID!) {
  journey(id: $id) {
    __typename
    ...Error
    ...Journey
  }
}
fragment Error on Error {
  message
  id
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
`);

export const UpdateJourney = new Mutation<UpdateJourneyMutationVariables, UpdateJourneyMutation>(gql_`
mutation UpdateJourney($id: UUID!, $distance: Int) {
  updateJourney(id: $id, distance: $distance) {
    __typename
    ...Error
    ...Journey
  }
}
fragment Error on Error {
  message
  id
}
fragment Journey on Journey {
  id
  origin {
    ...Place
  }
  destination {
    ...Place
  }
  waypoints {
    ...Place
  }
  distance
  timeZoneId
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
`);

export const Locales = new Query<{}, LocalesQuery>(gql_`
query Locales {
  locales {
    ...Locale
  }
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
`);

export const PastPassengers = new Query<PastPassengersQueryVariables, PastPassengersQuery>(gql_`
query PastPassengers($forBookerId: UUID) {
  pastPassengers(forBookerId: $forBookerId) {
    ...PastPassenger
  }
}
fragment PastPassenger on PastPassenger {
  count
  name
  email
  mobile
  phone
}
`);

export const Place = new Query<PlaceQueryVariables, PlaceQuery>(gql_`
query Place($id: UUID!) {
  place(id: $id) {
    ...Place
  }
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
`);

export const PlaceNicknames = new Query<{}, PlaceNicknamesQuery>(gql_`
query PlaceNicknames {
  placeNicknames {
    ...PlaceNickname
  }
}
fragment PlaceNickname on PlaceNickname {
  id
  label
}
`);

export const PlaceSuggest = new Query<PlaceSuggestQueryVariables, PlaceSuggestQuery>(gql_`
query PlaceSuggest($localeId: UUID!, $text: String!, $raw: Boolean) {
  placeSuggestions(localeId: $localeId, text: $text, raw: $raw) {
    ...Place
  }
}
fragment Place on Place {
  id
  googlePlaceId
  optionalName
  address
  type
  category
  isAirportStop
}
`);

export const CreateStripeCard = new Mutation<CreateStripeCardMutationVariables, CreateStripeCardMutation>(gql_`
mutation CreateStripeCard($token: String!, $forBookerId: UUID!) {
  createStripeCard(token: $token, forBookerId: $forBookerId) {
    __typename
    ...Error
    ... on UUIDObj {
      uuid
    }
  }
}
fragment Error on Error {
  message
  id
}
`);

export const StripeCard = new Query<StripeCardQueryVariables, StripeCardQuery>(gql_`
query StripeCard($id: UUID!) {
  stripeCard(id: $id) {
    __typename
    ...Error
    ... on StripeCardOrNull {
      stripeCard {
        ...StripeCard
      }
    }
  }
}
fragment Error on Error {
  message
  id
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const StripeCards = new Query<StripeCardsQueryVariables, StripeCardsQuery>(gql_`
query StripeCards($forBookerId: UUID!) {
  stripeCards(forBookerId: $forBookerId) {
    __typename
    ...Error
    ... on StripeCards {
      stripeCards {
        ...StripeCard
      }
    }
  }
}
fragment Error on Error {
  message
  id
}
fragment StripeCard on StripeCard {
  id
  last4
  brand
  expiryYear
  expiryMonth
  bookerName
  bookerId
}
`);

export const StripeConfig = new Query<{}, StripeConfigQuery>(gql_`
query StripeConfig {
  stripeConfig {
    publicKey
  }
}
`);

export const XeroInvoice = new Query<XeroInvoiceQueryVariables, XeroInvoiceQuery>(gql_`
query XeroInvoice($id: UUID!) {
  xeroInvoice(id: $id) {
    id
    contact {
      email
      name
    }
    number
    paid
    owing
    total
    xeroUuid
  }
}
`);

export const InvoiceByNumber = new Query<InvoiceByNumberQueryVariables, InvoiceByNumberQuery>(gql_`
query InvoiceByNumber($number: String!) {
  invoiceByNumber(invoiceNumber: $number) {
    __typename
    ...Error
    ...Invoice
  }
}
fragment Error on Error {
  message
  id
}
fragment Invoice on Invoice {
  id
  number
  xeroInvoiceReady
}
`);

export const CreateStripeCharge = new Mutation<CreateStripeChargeMutationVariables, CreateStripeChargeMutation>(gql_`
mutation CreateStripeCharge($invoiceId: UUID!, $stripeToken: String!, $amountCents: Int!) {
  createStripeCharge(invoiceId: $invoiceId, stripeToken: $stripeToken, amountCents: $amountCents) {
    ...StripeChargeFrag
  }
}
fragment StripeChargeFrag on StripeCharge {
  __typename
  id
  isComplete
  isFailed
  failedMessage
}
`);

export const StripeCharge = new Query<StripeChargeQueryVariables, StripeChargeQuery>(gql_`
query StripeCharge($id: UUID!) {
  stripeCharge(id: $id) {
    ...StripeChargeFrag
  }
}
fragment StripeChargeFrag on StripeCharge {
  __typename
  id
  isComplete
  isFailed
  failedMessage
}
`);

export const ResendInvoice = new Mutation<ResendInvoiceMutationVariables, ResendInvoiceMutation>(gql_`
mutation ResendInvoice($invoiceId: UUID!) {
  resendInvoice(invoiceId: $invoiceId) {
    __typename
    ...Error
    ...SendInvoiceJob
  }
}
fragment Error on Error {
  message
  id
}
fragment SendInvoiceJob on SendInvoiceJob {
  id
  isComplete
  isFailed
}
`);

export const ResendInvoiceStatus = new Query<ResendInvoiceStatusQueryVariables, ResendInvoiceStatusQuery>(gql_`
query ResendInvoiceStatus($id: UUID!) {
  resendInvoiceStatus(id: $id) {
    __typename
    ...Error
    ...SendInvoiceJob
  }
}
fragment Error on Error {
  message
  id
}
fragment SendInvoiceJob on SendInvoiceJob {
  id
  isComplete
  isFailed
}
`);

export const UpsertCommonPlace = new Mutation<UpsertCommonPlaceMutationVariables, UpsertCommonPlaceMutation>(gql_`
mutation UpsertCommonPlace($commonPlace: CommonPlaceInput!) {
  upsertCommonPlace(commonPlace: $commonPlace) {
    ...CommonPlace
    ...Error
    __typename
  }
}
fragment CommonPlace on CommonPlace {
  id
  placeId
  locale {
    ...Locale
  }
  label
  shortLabel
  suggest
  category
}
fragment Locale on Locale {
  id
  label
  mapLatitude
  mapLongitude
  countryCode
}
fragment Error on Error {
  message
  id
}
`);

export const UpsertPlaceNickname = new Mutation<UpsertPlaceNicknameMutationVariables, UpsertPlaceNicknameMutation>(gql_`
mutation UpsertPlaceNickname($id: UUID!, $label: String!) {
  upsertPlaceNickname(id: $id, label: $label) {
    __typename
    ...Error
    ...PlaceNickname
  }
}
fragment Error on Error {
  message
  id
}
fragment PlaceNickname on PlaceNickname {
  id
  label
}
`);

export const BecomeDriver = new Mutation<BecomeDriverMutationVariables, BecomeDriverMutation>(gql_`
mutation BecomeDriver($driverSmsId: UUID!) {
  becomeDriver(driverSignupSmsId: $driverSmsId) {
    __typename
    ...Error
  }
}
fragment Error on Error {
  message
  id
}
`);



// WEBPACK FOOTER //
// ./src/graphql/queries.ts